<template>
  <v-container background fluid pa-2>
    <!-- <filter-component :json_data ="form_filter_data" v-on:set="onCloseFormDialog" /> -->
    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>
    <!-- <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter" >
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn> -->
    <v-layout row wrap hidden-xs-only>
      <!-- <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex> -->
    </v-layout>
    <!-- <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field solo label="ค้นหา..." v-model="Search_data" @input="searchProcess()" append-icon="search" style="margin-bottom: 0px"></v-text-field>
      </v-flex>
    </v-layout> -->
    <div class="text-xs-center">
      <v-dialog v-model="dialog_loading" persistent width="350">
        <v-card>
          <v-card-text>
            Processing... <span v-if="progress > 0">{{ progress }}%</span>
            <v-progress-linear :value="progress" max="100" v-if="progress > 0"></v-progress-linear>
            <div v-if="snackbar">{{ errmsg }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-layout row wrap pa-3 style="background-color: #fff; margin: 10px; border-radius: 5px">
      <!-- command box -->
      <v-flex md12 sm12 xs12 ma-2>
        <v-layout row wrap>
          <v-flex md12 xs12 px-1>
            <v-text-field label="ค้นหา..." v-model="Search_data" append-icon="search" style="margin-bottom: 0px"></v-text-field>
          </v-flex>
          <v-flex md4 xs12 px-1>
            <v-select
              :items="Branch_List"
              label="สาขา"
              item-text="name"
              item-value="code"
              v-model="branchSelect"
              hide-details
              :rules="form_rules.branch"
              required
              @input="selectbranch()"
              style="margin-bottom: 15px"
            />
          </v-flex>
          <v-flex md4 xs12 px-1>
            <v-select
              :items="Department_List"
              label="แผนก"
              item-text="name"
              item-value="code"
              v-model="departmentSelect"
              hide-details
              @input="selectbranch()"
              style="margin-bottom: 15px"
            />
          </v-flex>
          <v-flex md4 xs12 px-1>
            <v-select
              :items="Position_List"
              label="ฝ่าย"
              item-text="name"
              item-value="code"
              v-model="positionSelect"
              hide-details
              @input="selectbranch()"
              style="margin-bottom: 15px"
            />
          </v-flex>
          <v-flex md4 xs12 px-1>
            <v-select
              :items="selectitems"
              :item-text="$t('txt')"
              item-value="val"
              :label="$t('duration')"
              v-model="ChoiceSelected"
              @change="selectChoice()"
              style="margin-bottom: 15px"
            >
              <template slot="item" slot-scope="{ item }">
                <div>{{ $t(item.txt) }}</div>
              </template>
            </v-select>
          </v-flex>
          <v-flex md4 xs12 px-1>
            <v-text-field :label="$t('fromdate')" type="date" v-model="from_date" hide-details style="margin-bottom: 15px" />
          </v-flex>
          <v-flex md4 xs12 px-1>
            <v-text-field :label="$t('todate')" type="date" v-model="to_date" hide-details style="margin-bottom: 15px" />
          </v-flex>
          <v-flex md12 sm12 xs12 class="hidden-sm-and-up">
            <v-btn slot="activator" color="primary" dark fixed bottom right fab @click="buttondocDialog = true">
              <v-icon>apps</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md12 sm12 xs12 ma-2>
        <v-layout row wrap>
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="success" @click="process()">
              <v-icon class="pr-2" size="16">fa-spinner</v-icon>
              <span>{{ $t("processor") }}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1 class="hidden-xs-only" v-if="permission_edit == true || admin == 'true'">
            <v-btn block color="primary" @click="showCreateDocDialog()">
              <v-icon class="pr-2" size="16">fa-plus</v-icon>
              <span>{{ $t("Createpaymentdocuments") }}</span>
            </v-btn>
          </v-flex>

          <v-flex md2 sm6 xs12 px-1 class="hidden-xs-only" v-if="buttonlist == 1 && (permission_edit == true || admin == 'true')">
            <v-btn block color="info" @click="checkbutton(1, 'downloadexcel')">
              <v-icon class="pr-2" size="16">fa-file-excel</v-icon>
              <span>{{ $t("Exportexcel") }}</span>
            </v-btn>
          </v-flex>
          <!--  <v-flex md2 xs6 px-1>
            <v-btn block color="primary" >
              <v-icon class="pr-2" size="16">fa-copy</v-icon>
              <span>open in sheet</span>
            </v-btn>
          </v-flex>-->

          <v-flex md2 sm6 xs12 px-1 class="hidden-xs-only" v-if="buttonlist == 1 && (permission_edit == true || admin == 'true')">
            <v-btn block color="primary" @click="checkbutton(1, 'doCopyTable')">
              <v-icon class="pr-2" size="16">fa-copy</v-icon>
              <span>{{ $t("copy") }}</span>
            </v-btn>
          </v-flex>
          <!--  <v-flex md2 xs6 px-1>
            <v-btn block color="info">
              <v-icon class="pr-2" size="16">fa-print</v-icon>
              <span>พิมพ์รายงาน</span>
            </v-btn>
          </v-flex>-->
          <!-- <v-flex md2 sm6 xs12 px-10 v-if="buttonlist == 0">
            <v-btn block color="warning" style="visibility:hidden" >
              <v-icon class="pr-2" size="16">fa-info</v-icon>
              <span>{{$t('showdetails')}}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-10 v-else>
            <v-btn block color="warning">
              <v-icon class="pr-2" size="16">fa-info</v-icon>
              <span>{{$t('showdetails')}}</span>
            </v-btn>
          </v-flex> -->
          <!-- <v-flex md2 sm6 xs12 px-1 v-if="buttonlist == 0 && (permission_edit == true || admin == 'true')">
            <v-btn block dark color="deep-purple" @click="filterDialog = true" style="visibility: hidden">
              <v-icon class="pr-2" size="16">fa-filter</v-icon>
              <span>{{ $t("displayoptions") }}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1 v-if="buttonlist == 1 && (permission_edit == true || admin == 'true')">
            <v-btn block dark color="deep-purple" @click="filterDialog = true">
              <v-icon class="pr-2" size="16">fa-filter</v-icon>
              <span>{{ $t("displayoptions") }}</span>
            </v-btn>
          </v-flex> -->
        </v-layout>

        <v-layout row wrap class="hidden-xs-only content">
          <v-flex xs12 v-if="permission_edit == true || admin == 'true'">
            <v-btn dark v-if="buttonlist == 0" color="blue-grey darken-2" @click="checkbutton(1, 'display')">
              <v-icon dark>fa-table</v-icon>
            </v-btn>
            <v-btn dark v-else color="light-blue accent-4" @click="checkbutton(1, 'display')">
              <v-icon dark>fa-table</v-icon>
            </v-btn>
            <v-btn dark v-if="buttonlist == 1" color="blue-grey darken-2" @click="checkbutton(0, 'display')">
              <v-icon dark>fa-list</v-icon>
            </v-btn>
            <v-btn dark v-else color="light-blue accent-4" @click="checkbutton(0, 'display')">
              <v-icon dark>fa-list</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-layout row wrap v-if="buttonlist == 0 && (permission_edit == true || admin == 'true')">
            <v-container
              fluid
              pt-3
              style="
                border-right: 0px;
                border-left: 0px;
                padding-right: 0px;
                padding-bottom: 0px;
                padding-left: 0px;
              "
            >
              <v-layout row wrap>
                <v-flex md12 sm12 xs12 class="hidden-sm-and-up">
                  <!-- ไม่แสดงขนาดกลางและขนาดใหญ๋ -->
                  <v-expansion-panel expand>
                    <v-expansion-panel-content style="background-color: #ffffff; margin: 0px" v-for="(item, i) in table_datalist_resign" :key="i" expand-icon>
                      <div slot="header">
                        <v-card class="coco-box-shadow">
                          <v-layout align-center justify-center row fill-height wrap>
                            <v-flex lg1 md1 sm2 xs12 text-xs-center>
                              <v-avatar v-if="item.emp_images == '' || item.emp_images == undefined || item.emp_images == null" :size="64" color="teal">
                                <span class="white--text headline">{{ item.nickName }}</span>
                              </v-avatar>

                              <Empimage v-if="item.emp_images != '' && item.emp_images != undefined && item.emp_images != null" :json_data="item.emp_images" />
                            </v-flex>

                            <v-flex lg9 md9 sm8 xs12>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content">
                                  <span class="coco-list-label-text content">{{ item.code }} :</span>
                                  <span>{{ item.nameTitle }}</span>
                                  <span>{{ item.firstName }}</span>
                                  <span>{{ item.lastName }}</span>
                                  <span style="margin-left: 10px; font-weight: bold">{{ item.position }}</span>
                                  <!-- <span v-if="item.empType == 0 ">
                                    <strong style="color:green;">&nbsp;รายเดือน</strong>
                                  </span>
                                  <span v-if="item.empType == 1 ">
                                    <strong style="color:green;">&nbsp;รายวัน</strong>
                                  </span>
                                  <span v-if="item.empType == 2 ">
                                    <strong style="color:green;">&nbsp;รายชั่วโมง</strong>
                                  </span>-->
                                </v-flex>

                                <v-flex xs5 class="hidden-sm-and-up">
                                  <br />
                                  <span class="coco-list-label-text content">{{ item.code }} :</span>

                                  <!-- <span v-if="item.empType == 0 ">
                                    <strong style="color:green;">&nbsp;รายเดือน</strong> 
                                  </span>
                                  <span v-if="item.empType == 1 ">
                                    <strong style="color:green;">&nbsp;รายวัน</strong>
                                  </span>
                                  <span v-if="item.empType == 2 ">
                                    <strong style="color:green;">&nbsp;รายชั่วโมง</strong>
                                  </span>-->
                                </v-flex>
                                <v-flex xs7 class="hidden-sm-and-up">
                                  <br />
                                  <span>{{ item.nameTitle }} {{ item.firstName }} {{ item.lastName }}</span>
                                </v-flex>

                                <v-flex xs5 class="hidden-sm-and-up">
                                  <span class="coco-list-label-text content">{{ $t("Position") }} :</span>
                                </v-flex>
                                <v-flex xs7 class="hidden-sm-and-up">
                                  <span>{{ item.position }}</span>
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Salary") + " : " }}
                                      </span>
                                      <span>{{ thousandSep(item.salary) }}</span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Totalincome") + " : " }}
                                        <span>{{ thousandSep(item.totalEarning) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Deductions") + " : " }}
                                        <span>{{ item.totalDeduct }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span v-if="item.paymentType == 0" class="coco-list-label-text hidden-xs-only">
                                        {{ isEmpty(item.bankName) ? item.bankName + ":" : "" }}
                                        <span>
                                          {{ isEmpty(item.bankCode) ? item.bankCode : "" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 1" class="coco-list-label-text hidden-xs-only">
                                        {{ $t("Prompay") + ":" }}
                                        <span>
                                          {{ isEmpty(item.promptpayNumber) ? item.promptpayNumber : "" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 2" class="coco-list-label-text hidden-xs-only">เงินสด</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <!-- <v-flex xs5 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">{{ $t("Salary") + " : " }}</span>
                                    </v-flex>
                                    <v-flex xs7 class="hidden-sm-and-up">
                                      <span>{{ thousandSep(item.salary) }}</span>
                                    </v-flex> -->
                                    <v-flex xs5 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">{{ $t("Totalincome") + " : " }}</span>
                                    </v-flex>
                                    <v-flex xs7 class="hidden-sm-and-up">
                                      <span>{{ thousandSep(item.totalEarning) }}</span>
                                    </v-flex>
                                    <v-flex xs5 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">{{ $t("Deductions") + " : " }}</span>
                                    </v-flex>
                                    <v-flex xs7 class="hidden-sm-and-up">
                                      <span>{{ item.totalDeduct }}</span>
                                    </v-flex>

                                    <!-- //จอมือถือ// -->
                                    <v-flex xs5 class="hidden-sm-and-up" v-if="item.paymentType == 0">
                                      <span class="coco-list-label-text">
                                        {{ isEmpty(item.bankName) ? item.bankName + ":" : "" }}
                                      </span>
                                    </v-flex>
                                    <v-flex xs7 class="hidden-sm-and-up" v-if="item.paymentType == 0">
                                      <span> {{ isEmpty(item.bankCode) ? item.bankCode : "" }}</span>
                                    </v-flex>

                                    <v-flex xs5 class="hidden-sm-and-up" v-if="item.paymentType == 1">
                                      <span class="coco-list-label-text">
                                        {{ $t("Prompay") + ":" }}
                                      </span>
                                    </v-flex>
                                    <v-flex xs7 class="hidden-sm-and-up" v-if="item.paymentType == 1">
                                      <span> {{ isEmpty(item.promptpayNumber) ? item.promptpayNumber : "" }}</span>
                                    </v-flex>

                                    <v-flex xs12 class="hidden-sm-and-up" v-if="item.paymentType == 2">
                                      <span class="coco-list-label-text">
                                        เงินสด
                                      </span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg2 md2 sm2 xs12 text-xs-right pa-3>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <span>
                                    <strong>
                                      <h3 style="color: green; padding-right: 2px">
                                        {{ thousandSep(item.totalBalance) }}
                                      </h3>
                                    </strong>
                                  </span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </div>
                      <v-card-text class="coco-box-shadow">
                        <!-- เพิ่มใหม่แสดงวันที่เริ่มงาน hidden-sm-only -->
                        <v-layout row wrap>
                          <v-flex lg7 md7 sm7 xs5>
                            <span class="coco-list-label-text hidden-sm-only">{{ $t("StartworkingDate") + " : " }} </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7>
                            <span>{{ selectedformatDates(item.startWorkingDate) }}</span>
                          </v-flex>

                          <v-flex lg7 md7 sm7 xs5>
                            <span class="coco-list-label-text hidden-sm-only"> {{ $t("WorkingDate") + " : " }}</span>
                          </v-flex>

                          <v-flex lg7 md7 sm7 xs7>
                            <span>{{ item.workingDate }}</span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span class="coco-list-label-text hidden-sm-only">
                              {{$t('WorkingDate') + ' : '}}
                              <span>{{item.workingDate}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <!-- <v-flex lg7 md7 sm7 xs5 v-if="item.empType == 0">
                            <span class="hidden-sm-only" style="color: #b5b5b5; font-weight: 400">{{ $t("Salary") }}: </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.empType == 0">
                            <span style="color: green">{{ thousandSep(item.salary) }}</span>
                          </v-flex> -->

                          <v-flex lg7 md7 sm7 xs5 v-if="item.empType == 1">
                            <span class="hidden-sm-only" style="color: #b5b5b5; fontweight: 400"> {{ $t("Perday") }}: </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.empType == 1">
                            <span style="color: green">{{ isEmpty(item.perDay) ? item.perDay.toFixed() : "Perday" }}</span>
                          </v-flex>

                          <v-flex lg7 md7 sm7 xs5 v-if="item.empType == 2">
                            <span class="hidden-sm-only" style="color: #b5b5b5; fontweight: 400">{{ $t("Perhour") }}: </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.empType == 2">
                            <span style="color: green">{{ isEmpty(item.perHour) ? item.perHour.toFixed() : "Perhour" }} </span>
                          </v-flex>

                          <v-flex lg7 md7 sm7 xs5 v-if="item.incomeCraft != 0 && item.incomeCraft != null">
                            <span class="hidden-sm-only" style="color: #b5b5b5">ค่าฝีมือ : </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.incomeCraft != 0 && item.incomeCraft != null">
                            <span style="color: green">{{ isEmpty(item.incomeCraft) ? thousandSep(item.incomeCraft) : "totaldeduct" }}</span>
                          </v-flex>

                          <v-flex lg7 md7 sm7 xs5 v-if="item.incomePosition != 0 && item.incomePosition != null">
                            <span class="hidden-sm-only" style="color: #b5b5b5">ค่าตำแหน่ง :</span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.incomePosition != 0 && item.incomePosition != null">
                            <span style="color: green">{{ isEmpty(item.incomePosition) ? thousandSep(item.incomePosition) : "totaldeduct" }} </span>
                          </v-flex>

                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span style="color:#B5B5B5">
                              รวมเงินได้ :
                              <span style="color:green;">{{thousandSep(item.salary)}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex lg7 md7 sm7 xs5 v-if="item.totalOT != 0 && item.totalot != null">
                            <span class="hidden-sm-only" style="color: #b5b5b5">ชม.OT:</span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.totalOT != 0 && item.totalot != null">
                            <span style="color: green">{{ isEmpty(item.totalOT) ? thousandSep(item.totalOT) : "totalOT" }}</span>
                          </v-flex>

                          <v-flex lg7 md7 sm7 xs5 v-if="item.totalOTEvent != 0 && item.totalOTEvent != null">
                            <span class="hidden-sm-only" style="color: #b5b5b5">
                              เงินOT :
                            </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.totalOTEvent != 0 && item.totalOTEvent != null">
                            <span style="color: green">{{ isEmpty(item.totalOTEvent) ? thousandSep(item.totalOTEvent) : "totalOTEvent" }}</span>
                          </v-flex>

                          <v-flex xs12>
                            <v-layout row warp v-for="(items, j) in table_datalist_resign[i].incomeAndExpenses" :key="j">
                              <v-flex lg7 md7 sm7 xs5 v-if="items.tranFlag == 0">
                                <span class="hidden-sm-only" style="color: #b5b5b5"> {{ items.name }} :</span>
                              </v-flex>
                              <v-flex lg7 md7 sm7 xs7 v-if="items.tranFlag == 0">
                                <span class="hidden-sm-only" style="color: green">{{ isEmpty(items.amount) ? thousandSep(items.amount) : "amount" }}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs5>
                            <span style="color: #b5b5b5">{{ $t("Totalincome") + ":" }}</span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7>
                            <span style="color: green">{{ thousandSep(item.totalEarning) }}</span>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex lg7 md7 sm7 xs5 v-if="item.totalAbsent != '0' && item.totalAbsent != null">
                            <span class="hidden-sm-only" style="color: #b5b5b5">ชม ขาดงาน : </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.totalAbsent != '0' && item.totalAbsent != null">
                            <span style="color: red">{{ isEmpty(item.totalAbsent) ? thousandSep(item.totalAbsent) : "totalAbsent" }}</span>
                          </v-flex>

                          <v-flex lg7 md7 sm7 xs5 v-if="item.deductAbsent != '0' && item.deductAbsent != null">
                            <span class="hidden-sm-only" style="color: #b5b5b5">หักเงินขาด: </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.deductAbsent != '0' && item.deductAbsent != null">
                            <span style="color: red">{{ isEmpty(item.deductAbsent) ? thousandSep(item.deductAbsent) : "deductAbsent" }}</span>
                          </v-flex>

                          <v-flex xs12>
                            <v-layout row warp v-for="(items, j) in table_datalist_resign[i].incomeAndExpenses" :key="j">
                              <v-flex lg7 md7 sm7 xs5 v-if="items.tranFlag == 1">
                                <span class="coco-list-label-text hidden-sm-only" style="color: #b5b5b5"> {{ items.name }} :</span>
                              </v-flex>
                              <v-flex lg7 md7 sm7 xs7 v-if="items.tranFlag == 1">
                                <span class="hidden-sm-only" style="color: red">{{ isEmpty(items.amount) ? thousandSep(items.amount) : "amount" }}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex lg7 md7 sm7 xs5 v-if="item.deductSS != '0' && item.deductSS != null">
                            <span class="hidden-sm-only" style="color: #b5b5b5">{{ $t("SocialSecurity") }} : </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.deductSS != '0' && item.deductSS != null">
                            <span style="color: red">{{ isEmpty(item.deductSS) ? thousandSep(item.deductSS) : "" }}</span>
                          </v-flex>

                          <v-flex lg7 md7 sm7 xs5 v-if="item.deductTax != '0' && item.deductTax != null">
                            <span class="hidden-sm-only" style="color: #b5b5b5"> {{ $t("Tax") + ":" }}</span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.deductTax != '0' && item.deductTax != null">
                            <span style="color: red"> {{ isEmpty(item.deductTax) ? thousandSep(item.deductTax) : "totaldeduct" }}</span>
                          </v-flex>

                          <v-flex lg3 md3 sm3 xs5>
                            <span style="color: #b5b5b5">{{ $t("Totalexpenses") + ":" }}</span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs7>
                            <span style="color: red">{{ thousandSep(item.totalDeduct) }}</span>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
                <v-flex md12 sm12 xs12 class="hidden-xs-only content">
                  <v-expansion-panel expand>
                    <v-expansion-panel-content style="background-color: #ffffff" v-for="(item, i) in table_datalist_resign" :key="i">
                      <div slot="header">
                        <v-card class="coco-box-shadow">
                          <v-layout align-center justify-center row fill-height wrap>
                            <v-flex lg1 md1 sm2 xs3 text-xs-center>
                              <v-avatar v-if="item.emp_images == '' || item.emp_images == undefined || item.emp_images == null" :size="64" color="teal">
                                <span class="white--text headline">{{ item.nickName }}</span>
                              </v-avatar>

                              <Empimage v-if="item.emp_images != '' && item.emp_images != undefined && item.emp_images != null" :json_data="item.emp_images" />
                            </v-flex>

                            <v-flex lg9 md9 sm8 xs6>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content">
                                  <span class="coco-list-label-text content">{{ item.code }} :</span>
                                  <span>{{ item.nameTitle }}</span>
                                  <span>{{ item.firstName }}</span>
                                  <span>{{ item.lastName }}</span>
                                  <span style="margin-left: 10px; font-weight: bold">{{ item.position }}</span>
                                  <!-- <span v-if="item.empType == 0 ">
                                    <strong style="color:green;">&nbsp;รายเดือน</strong>
                                  </span>
                                  <span v-if="item.empType == 1 ">
                                    <strong style="color:green;">&nbsp;รายวัน</strong>
                                  </span>
                                  <span v-if="item.empType == 2 ">
                                    <strong style="color:green;">&nbsp;รายชั่วโมง</strong>
                                  </span>-->
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                  <span class="coco-list-label-text content">{{ item.code }} :</span>
                                  <br />
                                  <span>{{ item.nameTitle }} {{ item.firstName }} {{ item.lastName }}</span>

                                  <span style="margin-left: 10px; font-weight: bold">{{ item.position }} &nbsp;</span>
                                  <!-- <span v-if="item.empType == 0 ">
                                    <strong style="color:green;">&nbsp;รายเดือน</strong>
                                  </span>
                                  <span v-if="item.empType == 1 ">
                                    <strong style="color:green;">&nbsp;รายวัน</strong>
                                  </span>
                                  <span v-if="item.empType == 2 ">
                                    <strong style="color:green;">&nbsp;รายชั่วโมง</strong>
                                  </span>-->
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <!-- <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Salary") + " : " }}
                                        <span>{{ thousandSep(item.salary) }}</span>
                                      </span>
                                    </v-flex> -->
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Totalincome") + " : " }}
                                        <span>{{ thousandSep(item.totalEarning) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span class="coco-list-label-text">
                                        {{ $t("Deductions") + " : " }}
                                        <span>{{ item.totalDeduct }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                      <span v-if="item.paymentType == 0" class="coco-list-label-text hidden-xs-only">
                                        {{ isEmpty(item.bankName) ? item.bankName + ":" : "" }}
                                        <span>
                                          {{ isEmpty(item.bankCode) ? item.bankCode : "" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 1" class="coco-list-label-text hidden-xs-only">
                                        {{ $t("Prompay") + ":" }}
                                        <span>
                                          {{ isEmpty(item.promptpayNumber) ? item.promptpayNumber : "" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 2" class="coco-list-label-text hidden-xs-only">เงินสด</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex lg12 md12 sm12 xs12>
                                  <v-layout row wrap>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{ $t("Salary") + " : " }}
                                        <span>{{ thousandSep(item.salary) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex lg2 md6 sm6 xs6 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{ $t("Totalincome") + " : " }}
                                        <span>{{ thousandSep(item.totalEarning) }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span class="coco-list-label-text">
                                        {{ $t("Deductions") + " : " }}
                                        <span>{{ item.totalDeduct }}</span>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 class="hidden-sm-and-up">
                                      <span v-if="item.paymentType == 0" class="coco-list-label-text">
                                        {{ isEmpty(item.bankName) ? item.bankName + ":" : "" }}
                                        <span>
                                          {{ isEmpty(item.bankCode) ? item.bankCode : "" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 1" class="coco-list-label-text">
                                        {{ $t("Prompay") + ":" }}
                                        <span>
                                          {{ isEmpty(item.promptpayNumber) ? item.promptpayNumber : "" }}
                                        </span>
                                      </span>
                                      <span v-if="item.paymentType == 2" class="coco-list-label-text">เงินสด</span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg2 md2 sm2 xs3 text-xs-right>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <span>
                                    <strong>
                                      <h3 style="color: green">
                                        {{ thousandSep(item.totalBalance) }}
                                      </h3>
                                    </strong>
                                  </span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </div>

                      <v-card-text class="coco-box-shadow">
                        <!-- เพิ่มใหม่ วันที่เริ่มงาน hidden-xs-only content-->
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span class="coco-list-label-text hidden-xs-only content">
                              {{ $t("StartworkingDate") + " : " }}
                              <span>{{ selectedformatDates(item.startWorkingDate) }}</span>
                            </span>
                            <span class="coco-list-label-text hidden-xs-only content">
                              {{ $t("WorkingDate") + " : " }}
                              <span>{{ item.workingDate }}</span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span class="coco-list-label-text hidden-xs-only content">
                              {{$t('WorkingDate') + ' : '}}
                              <span>{{item.workingDate}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span
                              v-if="item.empType == 0"
                              class="hidden-xs-only content"
                              style="
                                color: #b5b5b5;
                                fontweight: 400;
                                padding: 4px;
                              "
                            >
                              {{ $t("Salary") + " : " }}
                              <span style="color: green">{{ thousandSep(item.salary) }}</span>
                            </span>

                            <span
                              v-if="item.empType == 1"
                              class="hidden-xs-only content"
                              style="
                                color: #b5b5b5;
                                fontweight: 400;
                                padding: 4px;
                              "
                            >
                              {{ $t("Perday") + " : " }}
                              <span style="color: green">
                                {{ isEmpty(item.perDay) ? item.perDay.toFixed() : "Perday" }}
                              </span>
                            </span>

                            <span
                              v-if="item.empType == 2"
                              class="hidden-xs-only content"
                              style="
                                color: #b5b5b5;
                                fontweight: 400;
                                padding: 4px;
                              "
                            >
                              {{ $t("Perhour") + " : " }}
                              <span style="color: green">
                                {{ isEmpty(item.perHour) ? item.perHour.toFixed() : "Perhour" }}
                              </span>
                            </span>

                            <span v-if="item.incomeCraft == 0 || item.incomeCraft == null"></span>
                            <span v-else class="hidden-xs-only content" style="color: #b5b5b5; padding: 4px">
                              ค่าฝีมือ :
                              <span style="color: green">
                                {{ isEmpty(item.incomeCraft) ? item.incomeCraft : "totaldeduct" }}
                              </span>
                            </span>
                            <span v-if="item.incomePosition == 0 || item.incomePosition == null"></span>
                            <span v-else class="hidden-xs-only content" style="color: #b5b5b5; padding: 4px">
                              ค่าตำแหน่ง :
                              <span style="color: green">
                                {{ isEmpty(item.incomePosition) ? item.incomePosition : "totaldeduct" }}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <!-- <span style="color:#B5B5B5">
                              รวมเงินได้ :
                              <span style="color:green;">{{thousandSep(item.salary)}}</span>
                            </span>-->
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.totalOT == 0 || item.totalot == null"></span>
                            <span v-else class="hidden-xs-only content" style="color: #b5b5b5; padding: 4px">
                              ชม.OT :
                              <span style="color: green">
                                {{ isEmpty(item.totalOT) ? item.totalOT : "salary" }}
                              </span>
                            </span>
                            <span v-if="item.totalOTEvent == 0 || item.totalOTEvent == null"></span>
                            <span v-else class="hidden-xs-only content" style="color: #b5b5b5; padding: 4px">
                              เงินOT :
                              <span style="color: green">
                                {{ isEmpty(item.totalOTEvent) ? item.totalOTEvent : "salary" }}
                              </span>
                            </span>
                            <span v-for="(items, j) in table_datalist_resign[i].incomeAndExpenses" :key="j">
                              <span v-if="items.tranFlag == 0" class="hidden-xs-only content" style="color: #b5b5b5; padding: 4px">
                                {{ items.name }} :
                                <span style="color: green" class="hidden-xs-only content">
                                  <!-- {{isEmpty(items.amount) ?
                                  items.amount : 'amount'}}-->
                                  {{ items.amount }}
                                </span>
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <span style="color: #b5b5b5">
                              {{ $t("Totalincome") + ":" }}
                              <span style="color: green">{{ thousandSep(item.totalEarning) }}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg7 md7 sm7 xs12>
                            <span v-if="item.totalAbsent == '0' || item.totalAbsent == null"></span>
                            <span v-else class="hidden-xs-only content" style="color: #b5b5b5; padding: 4px">
                              ชม ขาดงาน:
                              <span style="color: red">
                                {{ isEmpty(item.totalAbsent) ? item.totalAbsent : "totalWorkhour" }}
                              </span>
                            </span>
                            <span v-if="item.deductAbsent == '0' || item.deductAbsent == null"></span>
                            <span v-else class="hidden-xs-only content" style="color: #b5b5b5; padding: 4px">
                              หักเงินขาด:
                              <span style="color: red">
                                {{ isEmpty(item.deductAbsent) ? item.deductAbsent : "deductAbsent" }}
                              </span>
                            </span>
                            <span v-for="(items, j) in table_datalist_resign[i].incomeAndExpenses" :key="j">
                              <span v-if="items.tranFlag == 1" class="hidden-xs-only content" style="color: #b5b5b5; padding: 4px">
                                {{ items.name }} :
                                <span style="color: red">
                                  {{ isEmpty(items.amount) ? items.amount : "amount" }}
                                </span>
                              </span>
                            </span>

                            <span v-if="item.deductSS == '0' || item.deductSS == null"></span>
                            <span v-else class="hidden-xs-only content" style="color: #b5b5b5; padding: 4px">
                              {{ $t("SocialSecurity") }} :
                              <span style="color: red">
                                {{ isEmpty(item.deductSS) ? item.deductSS : "" }}
                              </span>
                            </span>
                            <span v-if="item.deductTax == '0' || item.deductTax == null"></span>
                            <span v-else class="hidden-xs-only content" style="color: #b5b5b5; padding: 4px">
                              {{ $t("Tax") + ":" }}
                              <span style="color: red">
                                {{ isEmpty(item.deductTax) ? item.deductTax : "Tax" }}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs12>
                            <span style="color: #b5b5b5">
                              {{ $t("Totalexpenses") + ":" }}
                              <span style="color: red">{{ thousandSep(item.totalDeduct) }}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
            </v-container>
          </v-layout>
          <v-layout v-if="buttonlist == 1 && (permission_edit == true || admin == 'true')">
            <v-flex md12 sm12 xs12 style="max-height: 70vh" class="scroll-able" v-if="table_datalist.length > 0">
              <table id="table_detail" class="table table-bordered" style=" overflow: scroll;cursor:pointer;">
                <thead>
                  <tr
                    style="
                      background-color: #357ca5;
                      color: white;
                      vertical-align: middle;
                    "
                    v-html="showheadhtml"
                  ></tr>
                </thead>
                <tbody v-html="showbodyhtml"></tbody>
              </table>
            </v-flex>
            <v-flex md12 sm12 xs12 text-xs-center v-if="table_datalist.length == 0">
              <!-- <h3 style="color: #000">{{ $t("message.Docfail") }}</h3> -->
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
      <!-- FormDialog -->
      <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="snackbarcolor">
        {{ snackmsg }}
        <v-btn dark flat @click="snackbar = false">X</v-btn>
      </v-snackbar>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog v-model="docDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t("Employee_payroll_doc") }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field readonly :label="$t('DocumentID')" required v-model="payroll_doc.doc_no"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('Document creation date')" type="date" v-model="payroll_doc.doc_date"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('fromdate')" readonly v-model="payroll_doc.begin_date"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('todate')" readonly v-model="payroll_doc.end_date"></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('paydate')"  type="date" v-model="payroll_doc.pay_date"></v-text-field>
                </v-flex> -->
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('Document period date')" type="date" v-model="payroll_doc.period_date"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field :label="$t('remark')" v-model="payroll_doc.remark"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="docDialog = false">ปิด</v-btn>
            <v-btn color="blue darken-1" v-if="isProcessSave == false" flat @click="saveDocOptimized()">บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- ปุ่มกด -->
    <v-layout row justify-center>
      <v-dialog v-model="buttondocDialog" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md2 sm6 xs12 px-1>
                  <v-btn block color="primary" @click="showCreateDocDialog()">
                    <v-icon class="pr-2" size="16">fa-plus</v-icon>
                    <span>{{ $t("Createpaymentdocuments") }}</span>
                  </v-btn>
                </v-flex>
                <v-flex md2 sm6 xs12 px-1>
                  <v-btn block color="info" @click="checkbutton(1, 'downloadexcel')">
                    <v-icon class="pr-2" size="16">fa-file-excel</v-icon>
                    <span>{{ $t("Exportexcel") }}</span>
                  </v-btn>
                </v-flex>
                <v-flex md2 sm6 xs12 px-1>
                  <v-btn block color="primary" @click="checkbutton(1, 'doCopyTable')">
                    <v-icon class="pr-2" size="16">fa-copy</v-icon>
                    <span>{{ $t("copy") }}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="buttondocDialog = false">ยกเลิก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="filterDialog" persistent scrollable max-width="600px">
        <v-card>
          <v-toolbar dark color="primary">
            <!-- <v-tooltip bottom> -->
            <v-btn icon dark @click="filterDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <!-- <span>{{ $t('close') }}</span>
            </v-tooltip> -->
            <v-toolbar-title>{{ $t("displayoptions") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              flat
              dark
              @click="
                process();
                filterDialog = false;
              "
            >
              <v-icon>save</v-icon>
              <span class="px-2">{{ $t("save") }}</span>
            </v-btn>
          </v-toolbar>
          <v-card-text style="height: 300px">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-btn block color="info" @click="doToggleHeader('1')">{{ $t("DisplayAll") }}</v-btn>
                </v-flex>
                <v-flex xs6>
                  <v-btn block dark color="deep-orange" @click="doToggleHeader('0')">{{ $t("NoneDisplayAll") }}</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('type')" v-model="table_head_model.ประเภท" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('Position')" v-model="table_head_model.ตำแหน่ง" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('StartworkingDate')" v-model="table_head_model.วันเริ่มทำงาน" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('WorkingDate')" v-model="table_head_model.วันทำงานเดือนนี้" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('Salary')" v-model="table_head_model.เงินเดือน" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('craftAmount')" v-model="table_head_model.ค่าฝีมือ" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('PositionAmount')" v-model="table_head_model.ค่าตำแหน่ง" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('TotalMoney')" v-model="table_head_model.รวมเงินได้" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('Perday')" v-model="table_head_model.วันละ" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('PerHour')" v-model="table_head_model.ชั่วโมงละ" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('TotalOTHour')" v-model="table_head_model.ชม_OT_รวม" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('TotalOTAmount')" v-model="table_head_model.เงิน_OT_รวม" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('TotalOtherIncome')" v-model="table_head_model.รวมรายรับอื่นๆ" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('DetailsOfIncome')" v-model="table_head_model.รายละเอียดรายรับ" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('Commission')" v-model="table_head_model.เบี้ยขยัน" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('SpecialHoliday')" v-model="table_head_model.วันหยุดพิเศษ" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('SpecialHolidayIncome')" v-model="table_head_model.รายได้วันหยุดพิเศษ" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('TotalIncome')" v-model="table_head_model.รวมรายได้" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('TotalLeaveHours')" v-model="table_head_model.ชม_ลา_รวม" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('TotalDeductLeave')" v-model="table_head_model.หักเงินลา_รวม" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('LeaveNotDeductingMoney')" v-model="table_head_model.ลาไม่หักเงิน" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('TotalAdsenceHour')" v-model="table_head_model.ชม_ขาด_รวม" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('TotalDeductAdsence')" v-model="table_head_model.หักเงินขาด_รวม" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('TotalLate')" v-model="table_head_model.สาย_รวม" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('TotalDeductLate')" v-model="table_head_model.หักเงินสาย_รวม" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('TotalOutBeforeTime')" v-model="table_head_model.ออกก่อน_รวม" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('TotalDeductOutBeforeTime')" v-model="table_head_model.หักออกก่อน_รวม" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('SocialSecurity')" v-model="table_head_model.ประกันสังคม" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('Tax')" v-model="table_head_model.ภาษี" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('DetailsOfExpenses')" v-model="table_head_model.รายละเอียดรายจ่าย" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('TotalOtherExpenses')" v-model="table_head_model.รวมรายจ่ายอื่นๆ" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('TotalDeduct')" v-model="table_head_model.รวมหัก" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('TotalBalance')" v-model="table_head_model.คงเหลือเงิน" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('PaymentType')" v-model="table_head_model.ประเภทการจ่ายเงิน" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6>
                  <v-checkbox :label="$t('AccountNumber')" v-model="table_head_model.เลขที่บัญชี" value="1" hide-details />
                </v-flex>
                <v-flex md4 sm4 xs6 v-if="this.timeattendance == 1">
                  <v-checkbox :label="$t('TimeAttendance')" v-model="table_head_model.เวลาเข้างาน" value="1" hide-details />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import ProcessService from "@/services/ProcessService";
import PayrollService from "@/services/PayrollService";
import SettingService from "@/services/SettingService";
import UserService from "@/services/UserService";
import Empimage from "../../components/getempimage.vue";
import Utils from "@/utils/";
import XLSX from "xlsx";
import { constants } from "crypto";
import { chown } from "fs";
import FilterComponent from "./Filter";
export default {
  data: () => ({
    timeattendance: 0,
    Search_data: "",
    show_search: false,
    errmsg: "",
    data_for_save: [],
    payroll_doc: {
      doc_no: "",
      period_date: new Date().toISOString().substr(0, 10),
      doc_date: new Date().toISOString().substr(0, 10),
      begin_date: "",
      end_date: "",
      remark: "",
      pay_date: "",
      creator_code: localStorage._usercode,
    },
    form_filter_data: {
      status: false,
    },
    progress: 0,
    processCount: 0,
    isProcessSave: false,
    snackbarcolor: "red",
    docDialog: false,
    buttondocDialog: false,
    filterDialog: false,
    table_datalist: [],
    table_datalist_resign: [],
    table_head_model: {
      ชื่อ: "1",
      ประเภท: "0",
      ตำแหน่ง: "0",
      วันเริ่มทำงาน: "0",
      วันทำงานเดือนนี้: "0",
      เงินเดือน: "1",
      ค่าฝีมือ: "0",
      ค่าตำแหน่ง: "0",
      รวมเงินได้: "0",
      วันละ: "0",
      ชั่วโมงละ: "0",
      ชม_OT_รวม: "0",
      เงิน_OT_รวม: "0",
      รายละเอียดรายรับ: "1",
      รวมรายรับอื่นๆ: "1",
      เบี้ยขยัน: "0",
      วันหยุดพิเศษ: "0",
      รายได้วันหยุดพิเศษ: "0",
      รวมรายได้: "1",
      ชม_ลา_รวม: "0",
      หักเงินลา_รวม: "0",
      ลาไม่หักเงิน: "0",
      ชม_ขาด_รวม: "0",
      หักเงินขาด_รวม: "0",
      สาย_รวม: "0",
      หักเงินสาย_รวม: "0",
      ออกก่อน_รวม: "0",
      หักออกก่อน_รวม: "0",
      ประกันสังคม: "1",
      ภาษี: "1",
      รายละเอียดรายจ่าย: "1",
      รวมรายจ่ายอื่นๆ: "1",
      รวมหัก: "1",
      คงเหลือเงิน: "1",
      ประเภทการจ่ายเงิน: "1",
      เลขที่บัญชี: "1",
      เวลาเข้างาน: "0",
    },
    json_fields: {
      ชื่อ: "name",
      ประเภท: "empType",
      ตำแหน่ง: "position",
      วันเริ่มทำงาน: "startWorkingDate",
      วันทำงานเดือนนี้: "1",
      เงินเดือน: "salary",
      ค่าฝีมือ: "craftAmount",
      ค่าตำแหน่ง: "positionAmount",
      รวมเงินได้: "incomeBeforeExtraAndOT",
      วันละ: "perDay",
      ชั่วโมงละ: "perHour",
      ชม_OT_รวม: "OT",
      เงิน_OT_รวม: "OTAmount",
      รวมรายรับอื่นๆ: "totalAddIncome",
      เบี้ยขยัน: "totalCommission",
      วันหยุดพิเศษ: "extraHoliday",
      รายได้วันหยุดพิเศษ: "extraHolidayAmount",
      รวมรายได้: "incomeBeforeExpenses",
      ชม_ลา_รวม: "leaveAmount",
      หักเงินลา_รวม: "leaveAmountEvent",
      ลาไม่หักเงิน: "leaveUncut",
      ชม_ขาด_รวม: "absentAmount",
      หักเงินขาด_รวม: "absentAmountEvent",
      สาย_รวม: "totalLate",
      หักเงินสาย_รวม: "lateAmount",
      ออกก่อน_รวม: "totalOB",
      หักออกก่อน_รวม: "outBeforTimeAmount",
      ประกันสังคม: "insuranceAmount",
      ภาษี: "vatAmount",
      รายละเอียดรายจ่าย: "notCheckInAmount",
      รวมรายจ่ายอื่นๆ: "totalAddExpenses",
      รวมหัก: "deductAmount",
      คงเหลือเงิน: "balanceAmount",
      ประเภทการจ่ายเงิน: "paymentType",
      เลขที่บัญชี: "bankcode",
    },
    selectitems: [
      { txt: "None", val: "" },
      { txt: "ThisMount", val: 0 },
      { txt: "ThisWeek", val: 1 },
      { txt: "Today", val: 2 },
      { txt: "LastWeek", val: 3 },
      { txt: "LastMount", val: 4 },
    ],
    ChoiceSelected: "",
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    buttonlist: 1,
    table_head_count: 1,
    pageActive: 1,
    delDialogStatus: false,
    from_date: "",
    to_date: "",
    delDialog: {
      roworder: "",
      name: "",
      emp_code: "",
      date: "",
    },
    snackbar: false,
    snackmsg: "",
    snack_type: "",
    responvalue: "",
    showbodyhtml: "",
    showheadhtml: "",
    bodyHtml: "",
    footerHtml: "",
    dialog_loading: false,
    workhour_rate: [],
    ot_rate: [],
    absent_rate: [],
    leave_rate: [],
    ob_rate: [],
    ot_value: [],
    otobj: [],
    headReceive: [],
    headVat: [],
    headExpenses: [],
    earningDetailName: "",
    responvalue: [],
    late_rate: [],
    income: "",
    expenses: "",
    permission_edit: false,
    permission_view: false,
    admin: false,
    empCode: localStorage._empcode,
    permission: [],
    data_by_branch: [],
    result_data: [],
    form_rules: {
      branch: [(v) => !!v || "do not empty."],
    },
  }),
  created: async function() {
    var date = new Date();
    this.getProfileBranchList();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.from_date = this.selectedformatDate(firstDay);
    this.to_date = this.selectedformatDate(lastDay);
    this.timeattendance = localStorage._is_timeattendance;
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    await this.checkpermission("SalaryTableList");

    console.log(this.check_permission);
    this.admin = localStorage._is_admin;
    this.commitSetToolbar({
      patternTool: "0",
    });
    this.$store.watch(
      (state) => {
        state.filter.SelectBranch;
        state.filter.SelectDepartment;
        state.filter.SelectPosition;
        state.filter.SearchData;
      },
      () => {},
      {
        deep: true,
      }
    );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object,
    });
  },
  components: {
    Empimage,
    FilterComponent,
  },
  computed: {
    ...mapState("filter", [
      "Branch_List",
      "Department_List",
      "Position_List",
      "Errormsg",
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
    ]),
    ...mapState("app", ["showLoading"]),
    //...mapState("permissionmenu", ["permission_List"]),
    //   branchSelect: {
    //     get() {
    //       return this.SelectBranch;
    //     },
    //     async set(value) {
    //       await this.getDepartment({ branch: value });
    //     }
    //   },
    //   departmentSelect: {
    //     get() {
    //       return this.SelectDepartment;
    //     },
    //     async set(value) {
    //       await this.getPosition({ department: value });
    //     }
    //   },
    //   positionSelect: {
    //     get() {
    //       return this.SelectPosition;
    //     },
    //     async set(value) {
    //       await this.selectedPosition({ data: value });
    //     }
    //   }
    branchSelect: {
      get() {
        return this.SelectBranch;
      },
      async set(value) {
        await this.getDepartment({ branch: value });
      },
    },
    departmentSelect: {
      get() {
        return this.SelectDepartment;
      },
      async set(value) {
        await this.getPosition({ department: value });
      },
    },
    positionSelect: {
      get() {
        return this.SelectPosition;
      },
      async set(value) {
        await this.selectedPosition({ data: value });
      },
    },
  },
  mounted: function() {
    this.getBranch();
  },
  methods: {
    ...mapActions("filter", ["getBranch", "getDepartment", "getPosition"]),
    ...mapMutations("filter", ["setShowFilter", "selectedFormDate", "selectedto_date", "getAllEmployeeByBranch", "selectedPosition"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission.length != 0) {
        this.permission.forEach((element) => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    showFilter(status) {
      this.form_filter_data = {
        status: status,
        data: 1,
      };
    },

    onCloseFormDialog() {
      this.form_filter_data.status = false;
      this.onload = true;
      // this.process();
    },
    selectbranch() {
      let v = this;
      setTimeout(function() {
        if (this.branchSelect != "ALL" && this.departmentSelect == "ALL" && this.SelectPosition == "ALL") {
          v.$emit("set");
        } else if (this.branchSelect != "ALL" && this.departmentSelect != "ALL" && this.SelectPosition == "ALL") {
          v.$emit("set");
        } else if (this.branchSelect != "ALL" && this.departmentSelect != "ALL" && this.SelectPosition != "ALL") {
          v.$emit("set");
        } else {
          v.$emit("set");
        }
      }, 100);
    },
    saveDoc() {
      this.progress = 0;
      this.dialog_loading = true;
      if (this.table_datalist.length <= 0) {
        return;
      }
      this.isProcessSave = true;
      let searchVal = "";
      let department = "";
      //this.commitSetShowLoading(true);
      if (this.SearchData == undefined) {
        searchVal = "";
      } else {
        searchVal = this.SearchData;
      }
      if (this.SelectDepartment == "All" || this.SelectDepartment == "") {
        department = "";
      } else {
        department = this.SelectDepartment;
      }
   
      PayrollService.createPayrollDoc(
        searchVal,
        this.payroll_doc.doc_no,
        this.payroll_doc.doc_date,
        this.payroll_doc.begin_date,
        this.payroll_doc.end_date,

        this.SelectBranch,
        department,
        this.payroll_doc.remark,
        this.data_by_branch,
        this.payroll_doc.period_date
      )
        .then((res) => {
          this.commitSetShowLoading(false);
          this.snackbarcolor = "success";
          this.snackmsg = "สร้างเอกสารจ่ายเงินสำเร็จ";
          this.snackbar = true;
          this.docDialog = false;
          this.isProcessSave = false;
          this.dialog_loading = false;
        })
        .catch((err) => {
          this.commitSetShowLoading(false);
          this.snackbarcolor = "error";
          this.snackmsg = "เอกสารเดือนนี้ถูกสร้างแล้ว";
          this.snackbar = true;
          this.docDialog = false;
          this.isProcessSave = false;
          this.dialog_loading = false;
        });
    },
    saveDocOptimized() {
      this.progress = 0;
      if (!this.result_data || this.result_data.length === 0) {
        this.commitSetShowLoading(false);
          this.snackbarcolor = "error";
          this.snackmsg = "เอกสารเดือนนี้ถูกสร้างแล้ว";
          this.snackbar = true;
          this.isProcessSave = false;
        
        return;
      }
          let department = "";
     if (this.SelectDepartment == "All" || this.SelectDepartment == "") {
        department = "";
      } else {
        department = this.SelectDepartment;
      }
      const docData = {
        user_code: localStorage._usercode,
        doc_no: this.payroll_doc.doc_no,
        doc_date: this.payroll_doc.doc_date,
        start_date: this.payroll_doc.begin_date,
        end_date:  this.payroll_doc.end_date,
        branch: this.SelectBranch,
        dep:department,
        remark: this.payroll_doc.remark,
        result_data: this.data_for_save,
        data_by_branch:this.data_by_branch,
        period_date: this.payroll_doc.period_date
      };

      this.dialog_loading = true;
      console.log("Saving optimized document with data:", docData);
      PayrollService.createPayrollDocOptimized(
        docData.user_code,
        docData.doc_no,
        docData.doc_date,
        docData.start_date,
        docData.end_date,
        docData.branch,
        docData.dep,
        docData.remark,
        docData.result_data,
        docData.data_by_branch,
        docData.period_date
      )
        .then(() => {
         this.commitSetShowLoading(false);
          this.snackbarcolor = "success";
          this.snackmsg = "สร้างเอกสารจ่ายเงินสำเร็จ";
          this.snackbar = true;
          this.docDialog = false;
          this.isProcessSave = false;
          this.dialog_loading = false;
        })
        .catch((error) => {
                    this.commitSetShowLoading(false);
          this.snackbarcolor = "error";
          this.snackmsg = "เอกสารเดือนนี้ถูกสร้างแล้ว";
          this.snackbar = true;
          this.docDialog = false;
          this.isProcessSave = false;
          this.dialog_loading = false;
          console.error("Save Optimized Error:", error);
        });
    },
    downloadexcel() {
      //this.checkbutton(1);
      var config = { raw: true, type: "string" };
      var payroll = XLSX.utils.table_to_sheet(document.getElementById("table_detail"), config);
      //console.log(config);
      //console.log(payroll);
      var wb = XLSX.utils.book_new();
      //console.log(wb);
      XLSX.utils.book_append_sheet(wb, payroll, "payroll");
      XLSX.writeFile(wb, "salarytable.xlsx");
    },
    _today() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();

      var output = d.getFullYear() + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;

      return output;
    },
    showCreateDocDialog() {
      if (this.from_date == "" || this.from_date == undefined || this.to_date == "" || this.from_date == undefined || this.SelectBranch == "") {
        this.snackbar = true;
        this.snackmsg = "กรุณาประมวลผลเงินเดือนก่อนสร้างเอกสารจ่ายเงิน";
      } else {
        this.payroll_doc.doc_no = this._docno("PR") + localStorage._company_guid.substr(0, 6).toUpperCase() + this._docdate();
        this.payroll_doc.begin_date = this.from_date;
        this.payroll_doc.end_date = this.to_date;
        this.docDialog = true;
      }
    },
    _docno(head) {
      return (
        head +
        "-xxx".replace(/[xy]/g, function(c) {
          var r = (Math.random() * 8) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        })
      );
    },
    _docdate() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours();
      var min = d.getMinutes();

      var output = d.getFullYear() + "" + (month < 10 ? "0" : "") + month + "" + (day < 10 ? "0" : "") + day + hour + min;

      return output;
    },
    selectChoice() {
      //console.log(this.ChoiceSelected);
      if (this.ChoiceSelected == 0) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.from_date = this.selectedformatDate(firstDay);
        this.to_date = this.selectedformatDate(lastDay);

        // this.process();
      } else if (this.ChoiceSelected == 1) {
        var curr = new Date();
        var first = curr.getDate() - curr.getDay();
        var last = first + 6;
        var firstday = new Date(curr.setDate(first)).toUTCString();
        var lastday = new Date(curr.setDate(last)).toUTCString();
        this.from_date = this.selectedformatDate(firstday);
        this.to_date = this.selectedformatDate(lastday);
        // this.process();
      } else if (this.ChoiceSelected == 2) {
        var curr = new Date();
        this.from_date = this.selectedformatDate(curr);
        this.to_date = this.selectedformatDate(curr);
        // this.process();
      } else if (this.ChoiceSelected == 3) {
        var curr = new Date();
        var first = curr.getDate() - curr.getDay();
        var last = first - 6;
        var firstday = new Date(curr.setDate(first)).toUTCString();
        var lastday = new Date(curr.setDate(last)).toUTCString();
        if (curr.setDate(first) > curr.setDate(last)) {
          this.from_date = this.selectedformatDate(lastday);
          this.to_date = this.selectedformatDate(firstday);
        } else if (curr.setDate(first) < curr.setDate(last)) {
          this.from_date = this.selectedformatDate(firstday);
          this.to_date = this.selectedformatDate(lastday);
        }
        // this.process();
      } else if (this.ChoiceSelected == 4) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
        this.from_date = this.selectedformatDate(firstDay);
        this.to_date = this.selectedformatDate(lastDay);
        // this.process();
      } else {
        this.from_date = "";
        this.to_date = "";
      }
    },
    selectedformatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },

    getBranchName(code) {
      if (this.branch_items.filter((item) => item.code == code).length > 0) {
        return this.branch_items.filter((item) => item.code == code)[0].name;
      } else {
        return code;
      }
    },
    sortByName(data) {
      return data.sort((a, b) => {
        // Prioritize "เงินเดือน"
        if (a.name === "เงินเดือน" && b.name !== "เงินเดือน") {
          return -1;
        } else if (a.name !== "เงินเดือน" && b.name === "เงินเดือน") {
          return 1;
        }

        // For other names, sort alphabetically
        return a.name.localeCompare(b.name, "th");
      });
    },
    process() {
      this.headExpenses = [];
      this.headReceive = [];
      this.ot_rate = [];
      this.absent_rate = [];
      this.leave_rate = [];
      this.ob_rate = [];
      this.late_rate = [];
      this.processCount = 0;
      if (this.from_date == "" || this.to_date == "") {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกสาขาและวันที่";
      } else {
        this.commitSetShowLoading(true);
        let searchVal = "";
        if (this.Search_data == undefined) {
          searchVal = "";
        } else {
          searchVal = this.Search_data;
        }
        this.dialog_loading = true;
        this.payroll_doc.remark = "";
        console.log("search : " + this.SearchData);
        console.log("from_date : " + this.from_date);
        console.log("to_date : " + this.to_date);
        console.log("Branch : " + this.SelectBranch);

        ProcessService.getSalaryTableCount(this.SelectBranch, this.SelectDepartment, this.SelectPosition, searchVal, this.from_date, this.to_date)
          .then((res) => {
            console.log(res.data);
            this.processCount = res.data;
            this.processSalaryRun();
          })
          .catch((err) => {
            console.log(err);
          });

        // ProcessService.getSalaryTable(this.SelectBranch, this.SelectDepartment, this.SelectPosition, searchVal, this.from_date, this.to_date)

        //   .then((res) => {
        //     console.log(res.data);
        //     this.table_datalist = [];
        //     this.table_datalist_resign = [];
        //     this.headVat = [];
        //     this.data_by_branch  = [];
        //     this.headReceive = this.getUniqueHeaders(res.data);

        //     this.headReceive = this.sortByName(this.headReceive);

        //     // this.headReceive.forEach((element) => {
        //     //   this.headVat.push({ code: element.code, name: element.branchname });
        //     // });

        //     this.branch_items.forEach((element) => {
        //       if (element.code != "") {
        //         this.headVat.push({ code: element.code, name: element.name });
        //       }
        //     });

        //     const uniqueData = this.headVat.filter((v, i, a) => a.findIndex((t) => t.code === v.code) === i);

        //     this.headVat = uniqueData;

        //     let summaryByBranchArr = [];

        //     var ng = this;
        //     res.data.forEach((ele) => {
        //       var namex = ele.name.replace("(", "");
        //       for (var y = 0; y < ng.headVat.length; y++) {
        //         let rowz = ele.incomeAndExpenses.filter((c) => c.branchPay == ng.headVat[y].code && c.tranFlag == 0);
        //         for (var v = 0; v < rowz.length; v++) {
        //           let summaryByBranchObj = {
        //             doc_no:"tax",
        //             branch_code: ng.headVat[y].code,
        //             branch_name: ng.headVat[y].name,
        //             emp_code: ele.code,
        //             income_amount: rowz[v].amount,
        //             tax_type: rowz[v].taxType,
        //             not_cal_tax: rowz[v].notCalTax,
        //             emp_name: namex.replace(")", ""),
        //           };
        //           summaryByBranchArr.push(summaryByBranchObj);
        //         }
        //       }
        //     });

        //     this.result_data = { doc_no: "tax", details: [] };

        //     if (summaryByBranchArr.length > 0) {
        //       this.result_data = summaryByBranchArr.reduce(
        //         (acc, item) => {
        //           // Check if the branch already exists in the accumulator
        //           let branch = acc.details.find((branch) => branch.branch_code === item.branch_code);
        //           if (!branch) {
        //             // If not, create a new branch object and push it to the details array
        //             branch = {
        //               branch_code: item.branch_code,
        //               branch_name: item.branch_name,
        //               emp_list: [],
        //             };
        //             acc.details.push(branch);
        //           }

        //           // Add the employee to the emp_list of the branch

        //           if (item.income_amount != 0) {
        //             branch.emp_list.push({
        //               emp_code: item.emp_code,
        //               emp_name: item.emp_name,
        //               income_amount: item.income_amount,
        //               tax_type: item.tax_type,
        //               not_cal_tax: item.not_cal_tax,
        //             });
        //           }
        //           return acc;
        //         },
        //         { doc_no: summaryByBranchArr[0].doc_no, details: [] }
        //       );
        //     }

        //     ///////

        //     this.branch_items.forEach((branchMaster) => {
        //       if (branchMaster.code != "") {
        //         let table_details = [];
        //         let temp_details = [];
        //         let foundData = res.data.filter((c) => c.branch == branchMaster.code);

        //         if (foundData.length > 0) {
        //           foundData.forEach((item) => {
        //             temp_details.push({
        //               emp_code: item.code,
        //               emp_name: item.name,
        //               income_amount: item.salary,
        //               tax_type: "1",
        //               not_cal_tax: "0",
        //             });
        //           });
        //         }
        //         let data_branch = this.result_data.details.filter((d) => d.branch_code == branchMaster.code);

        //         if (data_branch.length > 0) {
        //           data_branch[0].emp_list.forEach((item) => {
        //             temp_details.push({
        //               emp_code: item.emp_code,
        //               emp_name: item.emp_name,
        //               income_amount: item.income_amount,
        //               tax_type: item.tax_type,
        //               not_cal_tax: item.not_cal_tax,
        //             });
        //           });
        //         }

        //         let uniqueEmps = new Map();

        //         temp_details.forEach((item) => {
        //           var namex = item.emp_name.replace("(", "");
        //           uniqueEmps.set(item.emp_code, { emp_code: item.emp_code, emp_name: namex.replace(")", "") });
        //         });

        //         // Converting the map values to an array
        //         let emplist = Array.from(uniqueEmps.values());
        //         //console.log("emplist ", emplist);

        //         emplist.forEach((emp) => {
        //           let empData = res.data.filter((c) => c.code == emp.emp_code);
        //           console.log("empData ", empData);
        //           let incomeTax = 0;
        //           let empSalary = 0;
        //           let totalAddIncome = 0;
        //           let totalAddIncomeExceptTax = 0;
        //           let salaryTax = 0;
        //           let prefix = "";
        //           let firstName = "";
        //           let lastName = "";
        //           let idcard = "";
        //           let address = "";

        //           if (empData.length > 0) {
        //             if (empData[0].branch == branchMaster.code) {
        //               empSalary = empData[0].salary;
        //               salaryTax = empData[0].processTaxDetail.salaryTax;
        //             }
        //             prefix = empData[0].nameTitle;
        //             firstName = empData[0].firstName;
        //             lastName = empData[0].lastName;
        //             idcard = empData[0].idCard;
        //             address = empData[0].address;
        //             incomeTax = empData[0].processTaxDetail.incomeTax;
        //             totalAddIncome = empData[0].totalAddIncome;
        //             totalAddIncomeExceptTax = empData[0].totalAddIncomeExceptTax;
        //           }

        //           // console.log("incomeTax ", incomeTax);
        //           // console.log("totalAddIncome ", totalAddIncome);
        //           // console.log("totalAddIncomeExceptTax ", totalAddIncomeExceptTax);

        //           let datax = temp_details.filter((item) => item.emp_code == emp.emp_code);
        //           let sumTotalIncome = 0;
        //           let sumTotalIncome1 = 0;
        //           let sumTotalIncome2 = 0;
        //           let sumTotalIncomeExcepttax = 0;
        //           let sumTotalIncomeExcepttax1 = 0;
        //           let sumTotalIncomeExcepttax2 = 0;
        //           let sumTotalTax = 0;
        //           let sumTotalTax1 = 0;
        //           let sumTotalTax2 = 0;
        //           let sumTotalBalance = 0;
        //           datax.forEach((element) => {
        //             if (element.not_cal_tax == "0") {
        //               sumTotalIncome += parseFloat(element.income_amount);
        //             } else {
        //               sumTotalIncomeExcepttax += parseFloat(element.income_amount);
        //             }
        //             if (element.tax_type == "1") {
        //               if (element.not_cal_tax == "0") {
        //                 sumTotalIncome1 += parseFloat(element.income_amount);
        //               } else {
        //                 sumTotalIncomeExcepttax1 += parseFloat(element.income_amount);
        //               }
        //             } else if (element.tax_type == "2") {
        //               if (element.not_cal_tax == "0") {
        //                 sumTotalIncome2 += parseFloat(element.income_amount);
        //               } else {
        //                 sumTotalIncomeExcepttax2 += parseFloat(element.income_amount);
        //               }
        //             }
        //           });

        //           // console.log("sumTotalIncome ", sumTotalIncome);
        //           // console.log("sumTotalIncomeExcepttax ", sumTotalIncomeExcepttax);
        //           sumTotalTax += salaryTax;

        //             var valueTax = (incomeTax * (sumTotalIncome - empSalary)) / (totalAddIncome - totalAddIncomeExceptTax);
        //             if (isNaN(valueTax)) {
        //               valueTax = 0;
        //             }
        //             sumTotalTax += valueTax;
        //             console.log(emp.emp_code + ";valueTax ", valueTax);
        //             sumTotalTax1 += (sumTotalTax * sumTotalIncome1) / (sumTotalIncome1 + sumTotalIncomeExcepttax1 + (sumTotalIncome2 + sumTotalIncomeExcepttax2));
        //             sumTotalTax2 += (sumTotalTax * sumTotalIncome2) / (sumTotalIncome1 + sumTotalIncomeExcepttax1 + (sumTotalIncome2 + sumTotalIncomeExcepttax2));

        //           sumTotalBalance = sumTotalIncome + sumTotalIncomeExcepttax - sumTotalTax;

        //           table_details.push({
        //             emp_code: emp.emp_code,
        //             emp_name: emp.emp_name,
        //             prefix: prefix,
        //             firstName: firstName,
        //             lastName: lastName,
        //             idcard: idcard,
        //             address: address,
        //             total_income1: sumTotalIncome1 + sumTotalIncomeExcepttax1,
        //             total_income2: sumTotalIncome2 + sumTotalIncomeExcepttax2,
        //             total_income: sumTotalIncome + sumTotalIncomeExcepttax,
        //             total_tax: sumTotalTax,
        //             total_tax1: sumTotalTax1,
        //             total_tax2: sumTotalTax2,
        //             total_balance: sumTotalBalance,
        //           });
        //         });
        //         this.data_by_branch.push({ branch_code: branchMaster.code, branch_name: branchMaster.name, details: table_details });
        //       }
        //     });
        //     console.log("this.data_by_branch", this.data_by_branch);
        //     console.log(this.headReceive);
        //     console.log("this.headVat", this.headVat);
        //     this.commitSetShowLoading(false);
        //     this.setShowDetail(res.data);

        //     this.table_datalist = res.data;
        //     this.table_datalist.forEach((element) => {
        //       if (element.isResign == false) {
        //         let value = element.name.split("(");
        //         let name = value[0];
        //         let nickname = "";
        //         if (value[1] != "" && value[1] != undefined) {
        //           let arrnickname = value[1].split(")");
        //           nickname = arrnickname[0];
        //         } else {
        //           nickname = "";
        //         }
        //         this.table_datalist_resign.push(element);
        //         console.log(this.table_datalist_resign);
        //       } else if (element.isResign == true && element.totalEarning > 0) {
        //         let value = element.name.split("(");
        //         let name = value[0];
        //         let nickname = "";
        //         if (value[1] != "" && value[1] != undefined) {
        //           let arrnickname = value[1].split(")");
        //           nickname = arrnickname[0];
        //         } else {
        //           nickname = "";
        //         }
        //         this.table_datalist_resign.push(element);
        //         console.log(this.table_datalist_resign);
        //       }
        //     });

        //     // console.log(this.table_datalist);
        //   })

        //   .catch((err) => {
        //     console.log(err);
        //   });
      }
    },
    chunkArray(processCount, size) {
      const result = [];
      for (let i = 0; i < processCount; i += size) {
        const chunk = array.slice(i, i + size);
        result.push(chunk);
      }
      return result;
    },
    async processSalaryRun() {
      this.commitSetShowLoading(true);
      let searchVal = "";
      if (this.Search_data == undefined) {
        searchVal = "";
      } else {
        searchVal = this.Search_data;
      }
      this.progress = 0;
      this.dialog_loading = true;
      const size = 50;
      const totalChunks = Math.ceil(this.processCount / size);

      let completedChunks = 0;
      var v = this;
      var dataWaitList = [];
      for (let i = 0; i < totalChunks; i++) {
        console.log("Processing chunk", i);
        try {
          const res = await ProcessService.getSalaryTableLimit(this.SelectBranch, this.SelectDepartment, this.SelectPosition, searchVal, this.from_date, this.to_date, i, size);
          console.log("Batch import successful", res);
          if (res.data.length > 0) {
            res.data.forEach((element) => {
              dataWaitList.push(element);
            });
          }
          completedChunks++;
          this.updateProgressBar(completedChunks, totalChunks);
        } catch (err) {
          console.error(err);
          this.dialog_loading = false;
          this.snackbar = true;
          this.errmsg = err.message;
          break; // Stop processing if there is an error
        }
      }
      if (completedChunks === totalChunks) {
        console.log("All chunks processed successfully");
        v.dialog_loading = false;
        if (dataWaitList.length > 0) {
          this.display_table(dataWaitList);
        }
      }
    },
    updateProgressBar(completedChunks, totalChunks) {
      this.progress = Math.round((completedChunks / totalChunks) * 100);
    },
    display_table(dataWaitList) {
      console.log(dataWaitList);
      this.data_for_save = dataWaitList;
      this.table_datalist = [];
      this.table_datalist_resign = [];
      this.headVat = [];
      this.data_by_branch = [];
      this.headReceive = this.getUniqueHeaders(dataWaitList);

      this.headReceive = this.sortByName(this.headReceive);

      // this.headReceive.forEach((element) => {
      //   this.headVat.push({ code: element.code, name: element.branchname });
      // });

      this.branch_items.forEach((element) => {
        if (element.code != "") {
          this.headVat.push({ code: element.code, name: element.name });
        }
      });

      const uniqueData = this.headVat.filter((v, i, a) => a.findIndex((t) => t.code === v.code) === i);

      this.headVat = uniqueData;

      let summaryByBranchArr = [];

      var ng = this;
      dataWaitList.forEach((ele) => {
        var namex = ele.name.replace("(", "");
        for (var y = 0; y < ng.headVat.length; y++) {
          let rowz = ele.incomeAndExpenses.filter((c) => c.branchPay == ng.headVat[y].code && c.tranFlag == 0);
          for (var v = 0; v < rowz.length; v++) {
            let summaryByBranchObj = {
              doc_no: "tax",
              branch_code: ng.headVat[y].code,
              branch_name: ng.headVat[y].name,
              emp_code: ele.code,
              income_amount: rowz[v].amount,
              tax_type: rowz[v].taxType,
              not_cal_tax: rowz[v].notCalTax,
              emp_name: namex.replace(")", ""),
            };
            summaryByBranchArr.push(summaryByBranchObj);
          }
        }
      });

      this.result_data = { doc_no: "tax", details: [] };

      if (summaryByBranchArr.length > 0) {
        this.result_data = summaryByBranchArr.reduce(
          (acc, item) => {
            // Check if the branch already exists in the accumulator
            let branch = acc.details.find((branch) => branch.branch_code === item.branch_code);
            if (!branch) {
              // If not, create a new branch object and push it to the details array
              branch = {
                branch_code: item.branch_code,
                branch_name: item.branch_name,
                emp_list: [],
              };
              acc.details.push(branch);
            }

            // Add the employee to the emp_list of the branch

            if (item.income_amount != 0) {
              branch.emp_list.push({
                emp_code: item.emp_code,
                emp_name: item.emp_name,
                income_amount: item.income_amount,
                tax_type: item.tax_type,
                not_cal_tax: item.not_cal_tax,
              });
            }
            return acc;
          },
          { doc_no: summaryByBranchArr[0].doc_no, details: [] }
        );
      }

      ///////

      this.branch_items.forEach((branchMaster) => {
        if (branchMaster.code != "") {
          let table_details = [];
          let temp_details = [];
          let foundData = dataWaitList.filter((c) => c.branch == branchMaster.code);
          console.log("foundData ", foundData);
          if (foundData.length > 0) {
            foundData.forEach((item) => {
              console.log("item", item);
              temp_details.push({
                emp_code: item.code,
                emp_name: item.name,
                income_amount: item.totalWorkDay < item.totalWorkDayCal ? item.perDay * item.totalWorkDay : item.salary,
                tax_type: "1",
                not_cal_tax: "0",
              });
            });
          }
          let data_branch = this.result_data.details.filter((d) => d.branch_code == branchMaster.code);
          console.log("data_branch", data_branch);
          if (data_branch.length > 0) {
            data_branch[0].emp_list.forEach((item) => {
              temp_details.push({
                emp_code: item.emp_code,
                emp_name: item.emp_name,
                income_amount: item.income_amount,
                tax_type: item.tax_type,
                not_cal_tax: item.not_cal_tax,
              });
            });
          }
          console.log("temp_details", temp_details);
          let uniqueEmps = new Map();

          temp_details.forEach((item) => {
            var namex = item.emp_name.replace("(", "");
            uniqueEmps.set(item.emp_code, { emp_code: item.emp_code, emp_name: namex.replace(")", "") });
          });

          // Converting the map values to an array
          let emplist = Array.from(uniqueEmps.values());
          console.log("emplist ", emplist);

          emplist.forEach((emp) => {
            let empData = dataWaitList.filter((c) => c.code == emp.emp_code);
            console.log("empData ", empData);
            let incomeTax = 0;
            let empSalary = 0;
            let totalAddIncome = 0;
            let totalAddIncomeExceptTax = 0;
            let salaryTax = 0;
            let prefix = "";
            let firstName = "";
            let lastName = "";
            let idcard = "";
            let address = "";

            if (empData.length > 0) {
              if (empData[0].isResign == false || (empData[0].isResign == true && empData[0].totalEarning > 0)) {
                if (empData[0].branch == branchMaster.code) {
                  if (empData[0].totalWorkDay < empData[0].totalWorkDayCal) {
                    empSalary = empData[0].perDay * empData[0].totalWorkDay;
                  } else {
                    empSalary = empData[0].salary;
                  }

                  salaryTax = empData[0].processTaxDetail.salaryTax;
                }
                prefix = empData[0].nameTitle;
                firstName = empData[0].firstName;
                lastName = empData[0].lastName;
                idcard = empData[0].idCard;
                address = empData[0].address;
                incomeTax = empData[0].processTaxDetail.incomeTax;
                totalAddIncome = empData[0].totalAddIncome;
                totalAddIncomeExceptTax = empData[0].totalAddIncomeExceptTax;
              }
            }

            // console.log("incomeTax ", incomeTax);
            // console.log("totalAddIncome ", totalAddIncome);
            // console.log("totalAddIncomeExceptTax ", totalAddIncomeExceptTax);

            let datax = temp_details.filter((item) => item.emp_code == emp.emp_code);
            console.log("datax ", datax);
            let sumTotalIncome = 0;
            let sumTotalIncome1 = 0;
            let sumTotalIncome2 = 0;
            let sumTotalIncomeExcepttax = 0;
            let sumTotalIncomeExcepttax1 = 0;
            let sumTotalIncomeExcepttax2 = 0;
            let sumTotalTax = 0;
            let sumTotalTax1 = 0;
            let sumTotalTax2 = 0;
            let sumTotalBalance = 0;
            datax.forEach((element) => {
              if (element.not_cal_tax == "0") {
                sumTotalIncome += parseFloat(element.income_amount);
              } else {
                sumTotalIncomeExcepttax += parseFloat(element.income_amount);
              }
              if (element.tax_type == "1") {
                if (element.not_cal_tax == "0") {
                  sumTotalIncome1 += parseFloat(element.income_amount);
                } else {
                  sumTotalIncomeExcepttax1 += parseFloat(element.income_amount);
                }
              } else if (element.tax_type == "2") {
                if (element.not_cal_tax == "0") {
                  sumTotalIncome2 += parseFloat(element.income_amount);
                } else {
                  sumTotalIncomeExcepttax2 += parseFloat(element.income_amount);
                }
              }
            });

            // console.log("sumTotalIncome ", sumTotalIncome);
            // console.log("sumTotalIncomeExcepttax ", sumTotalIncomeExcepttax);
            sumTotalTax += salaryTax;

            var valueTax = (incomeTax * (sumTotalIncome - empSalary)) / (totalAddIncome - totalAddIncomeExceptTax);
            if (isNaN(valueTax)) {
              valueTax = 0;
            }
            sumTotalTax += valueTax;
            console.log(emp.emp_code + ";valueTax ", valueTax);
            sumTotalTax1 += (sumTotalTax * sumTotalIncome1) / (sumTotalIncome1 + sumTotalIncomeExcepttax1 + (sumTotalIncome2 + sumTotalIncomeExcepttax2));
            sumTotalTax2 += (sumTotalTax * sumTotalIncome2) / (sumTotalIncome1 + sumTotalIncomeExcepttax1 + (sumTotalIncome2 + sumTotalIncomeExcepttax2));

            sumTotalBalance = sumTotalIncome + sumTotalIncomeExcepttax - sumTotalTax;
            console.log("empData.isResign ", empData[0].isResign);
            console.log("empData.totalEarning ", empData[0].totalEarning);

            if (empData[0].isResign == false || (empData[0].isResign == true && empData[0].totalEarning > 0)) {
              table_details.push({
                emp_code: emp.emp_code,
                emp_name: emp.emp_name,
                prefix: prefix,
                firstName: firstName,
                lastName: lastName,
                idcard: idcard,
                address: address,
                total_income1: sumTotalIncome1 + sumTotalIncomeExcepttax1,
                total_income2: sumTotalIncome2 + sumTotalIncomeExcepttax2,
                total_income: sumTotalIncome + sumTotalIncomeExcepttax,
                total_tax: sumTotalTax,
                total_tax1: sumTotalTax1,
                total_tax2: sumTotalTax2,
                total_balance: sumTotalBalance,
              });
            }
          });
          this.data_by_branch.push({ branch_code: branchMaster.code, branch_name: branchMaster.name, details: table_details });
        }
      });
      console.log("this.data_by_branch", this.data_by_branch);
      console.log(this.headReceive);
      console.log("this.headVat", this.headVat);
      this.commitSetShowLoading(false);
      this.setShowDetail(dataWaitList);

      this.table_datalist = dataWaitList;
      this.table_datalist.forEach((element) => {
        if (element.isResign == false) {
          let value = element.name.split("(");
          let name = value[0];
          let nickname = "";
          if (value[1] != "" && value[1] != undefined) {
            let arrnickname = value[1].split(")");
            nickname = arrnickname[0];
          } else {
            nickname = "";
          }
          this.table_datalist_resign.push(element);
          console.log(this.table_datalist_resign);
        } else if (element.isResign == true && element.totalEarning > 0) {
          let value = element.name.split("(");
          let name = value[0];
          let nickname = "";
          if (value[1] != "" && value[1] != undefined) {
            let arrnickname = value[1].split(")");
            nickname = arrnickname[0];
          } else {
            nickname = "";
          }
          this.table_datalist_resign.push(element);
          console.log(this.table_datalist_resign);
        }
      });
    },
    formatname(name) {
      console.log(name);
      let value = name.split("(");
      let n = value[0];
      let nickname = "";
      console.log(n, "dddd");
      console.log(value[1]);
      if (value[1] != "" && value[1] != undefined) {
        let arrnickname = value[1].split(")");
        nickname = arrnickname[0];
        // if(nickname==""){
        return n;
        // }
        // else{
        //    return n+'('+nickname+')';
        // }
      } else if (value[1] == undefined) {
        return n;
      }
    },
    searchProcess() {
      this.process("Filter");
    },
    searchClick() {
      if (this.show_search) {
        this.show_search = false;
        $("#pagetitleshow").removeClass("showtitlepage");
      } else {
        this.show_search = true;
        $("#pagetitleshow").addClass("showtitlepage");
        console.log($("#pagetitleshow"));
      }
    },
    getUniqueHeaders(data) {
      let headers = new Set();
      let v = this;

      data.forEach((item) => {
        item.incomeAndExpenses.forEach((entry) => {
          let branchname = "";
          if (entry.branchPay != "'") {
            if (v.branch_items.filter((item) => item.code == entry.branchPay).length > 0) {
              branchname = v.branch_items.filter((item) => item.code == entry.branchPay)[0].name;
            }
          }
          if (entry.tranFlag === 0) {
            let header = {
              code: entry.branchPay,
              name: entry.name,
              branchname: branchname,
              label: entry.name + (branchname ? ":" + branchname : ""),
            };
            headers.add(JSON.stringify(header)); // Use JSON string to ensure uniqueness
          }
        });
      });

      return Array.from(headers)
        .map((headerStr) => JSON.parse(headerStr))
        .sort((a, b) => {
          let branchPayComparison = (a.code || "").localeCompare(b.code || "");
          if (branchPayComparison !== 0) return branchPayComparison;
          return a.name.localeCompare(b.name);
        });
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      //console.log("win_scroll_top " + win_scroll_top);
      let width = $(".contain_width").width();
      //console.log("width " + width);
      if (win_scroll_top > 100) {
        $(".search_in_page").show();
        $(".search_in_page").css("width", width);
      } else {
        $(".search_in_page").hide();
      }
      /* if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          //this.getEmployeeList('List');
          console.log('last');
        }
        if(this.processing && this.canLoadMore){
          console.log('not last');
        }
       }*/
    },
    setShowDetail(response) {
      let ng = this;
      this.bodyHtml = "";
      this.footerHtml = "";
      this.responvalue = response;
      for (var i = 0; i < response.length; i++) {
        // for (var v = 0; v < response[i].processTimes.length; v++) {
        //   let valueOt = response[i].processTimes[v].ot_rate;
        //   if (typeof this.ot_rate.find((e) => e == valueOt) == "undefined") {
        //     let evObj = valueOt;
        //     if (evObj > 0.0) {
        //       this.ot_rate.push(parseFloat(evObj));
        //     }
        //   }
        //   let valueAbsent = response[i].processTimes[v].deduct_absent_rate;
        //   if (typeof this.absent_rate.find((e) => e == valueAbsent) == "undefined") {
        //     let evObj = valueAbsent;
        //     //console.log(evObj)
        //     if (evObj > 0.0) {
        //       this.absent_rate.push(parseFloat(evObj));
        //     }
        //   }
        //   let valueLeave = response[i].processTimes[v].deduct_leave_rate;
        //   if (typeof this.leave_rate.find((e) => e == valueLeave) == "undefined") {
        //     let evObj = valueLeave;

        //     this.leave_rate.push(parseFloat(evObj));
        //   }
        //   let valueOB = response[i].processTimes[v].deduct_ob_rate;
        //   if (typeof this.ob_rate.find((e) => e == valueOB) == "undefined") {
        //     let evObj = valueOB;
        //     if (evObj > 0.0) {
        //       this.ob_rate.push(parseFloat(evObj));
        //     }
        //   }
        //   let valueLate = response[i].processTimes[v].deduct_late_rate;
        //   if (typeof this.late_rate.find((e) => e == valueLate) == "undefined") {
        //     let evObj = valueLate;
        //     if (evObj > 0.0) {
        //       this.late_rate.push(parseFloat(evObj));
        //     }
        //   }
        // }
        for (var x = 0; x < response[i].incomeAndExpenses.length; x++) {
          let name = response[i].incomeAndExpenses[x].name;
          let flag = response[i].incomeAndExpenses[x].tranFlag;
          if (flag == 0) {
            if (typeof this.headReceive.find((e) => e == name) == "undefined") {
              let evObj = name;
              // this.headReceive.push(evObj);
            }
          } else {
            if (typeof this.headExpenses.find((e) => e == name) == "undefined") {
              let evObj = name;
              this.headExpenses.push(evObj);
            }
          }
        }
      }

      this.ot_rate = this.ot_rate.sort(function(a, b) {
        return a - b;
      });
      this.absent_rate = this.absent_rate.sort(function(a, b) {
        return a - b;
      });
      this.leave_rate = this.leave_rate.sort(function(a, b) {
        return a - b;
      });
      this.late_rate = this.late_rate.sort(function(a, b) {
        return a - b;
      });
      this.ob_rate = this.ob_rate.sort(function(a, b) {
        return a - b;
      });

      this.renderheader();

      response
        .sort(function(a, b) {
          a.code.localeCompare(b.code);
        })
        .sort(function(a, b) {
          a.department_name.localeCompare(b.department_name);
        });
      let retData = ng.groupBy(response, "department_name");
      let lastRowSummary = {
        salary: 0.0,
        craftAmount: 0.0,
        positionAmount: 0.0,
        incomeBeforeExtraAndOT: 0.0,
        perDay: 0.0,
        perHour: 0.0,
        extraAmount: 0.0,
        totalCommission: 0.0,
        extraHoliday: 0.0,
        extraHolidayAmount: 0.0,
        OT: 0.0,
        OTAmount: 0.0,
        totalAddIncome: 0.0,
        incomeBeforeExpenses: 0.0,
        leave: 0.0,
        leaveUncut: 0.0,
        leaveAmount: 0.0,
        leaveEvent: 0.0,
        leaveAmountEvent: 0.0,
        absent: 0.0,
        absentAmount: 0.0,
        absentEvent: 0.0,
        absentAmountEvent: 0.0,
        totalLate: 0.0,
        lateAmount: 0.0,
        totalOB: 0.0,
        outBeforTimeAmount: 0.0,
        insuranceAmount: 0.0,
        vatAmount: 0.0,
        notCheckInAmount: 0.0,
        employeeShirtAmount: 0.0,
        advanceAmount: 0.0,
        totalAddExpenses: 0.0,
        advancePayment: 0.0,
        deductAmount: 0.0,
        balanceAmount: 0.0,
        salaryTax: 0.0,
      };
      var lastSummaryOT = [];
      var lastSummaryOTInc = [];
      var lastSummaryLeave = [];
      var lastSummaryLeaveInc = [];
      var lastSummaryAbsent = [];
      var lastSummaryAbsentInc = [];
      var lastSummaryOb = [];
      var lastSummaryObInc = [];
      var lastSummaryLate = [];
      var lastSummaryLateInc = [];
      var lastSummaryTaxlevel = [];
      var lastSummaryReceive = [];
      var lastSummaryVat = [];
      var lastSummaryExpenses = [];
      console.log("retData: ", retData);
      for (let item in retData) {
        let departmentHtml = "";
        let rowHtml = "";
        let footerDepartmentHtml = "";
        let departName = item.toString() == "" ? "" : item.toString();
        departmentHtml += this.renderDepartment(departName, ng.ot_rate, ng.absent_rate, ng.leave_rate, ng.ob_rate, ng.late_rate, response, ng.headReceive, ng.headExpenses);
        var groupSummaryReceive = [];
        var groupSummaryVat = [];
        var groupSummaryExpenses = [];
        var groupSummaryOT = [];
        var groupSummaryOTInc = [];
        var groupSummaryLeave = [];
        var groupSummaryLeaveInc = [];
        var groupSummaryAbsent = [];
        var groupSummaryAbsentInc = [];
        var groupSummaryOb = [];
        var groupSummaryObInc = [];
        var groupSummaryLate = [];
        var groupSummaryLateInc = [];
        var groupSummaryTaxlevel = [];
        let groupSummary = {
          salary: 0.0,
          craftAmount: 0.0,
          positionAmount: 0.0,
          incomeBeforeExtraAndOT: 0.0,
          perDay: 0.0,
          perHour: 0.0,
          extraAmount: 0.0,
          totalCommission: 0.0,
          extraHoliday: 0.0,
          extraHolidayAmount: 0.0,
          OT: 0.0,
          OTAmount: 0.0,
          totalAddIncome: 0.0,
          incomeBeforeExpenses: 0.0,
          leave: 0.0,
          leaveUncut: 0.0,
          leaveAmount: 0.0,
          leaveEvent: 0.0,
          leaveAmountEvent: 0.0,
          absent: 0.0,
          absentAmount: 0.0,
          absentEvent: 0.0,
          absentAmountEvent: 0.0,
          totalLate: 0.0,
          lateAmount: 0.0,
          totalOB: 0.0,
          outBeforTimeAmount: 0.0,
          insuranceAmount: 0.0,
          vatAmount: 0.0,
          notCheckInAmount: 0.0,
          employeeShirtAmount: 0.0,
          advanceAmount: 0.0,
          totalAddExpenses: 0.0,
          advancePayment: 0.0,
          deductAmount: 0.0,
          balanceAmount: 0.0,
          salaryTax: 0.0,
        };

        retData[item].forEach(function(employee, i) {
          if (
            (employee.isResign == false && employee.totalWorkDay == 0 && employee.isSpecial == true) ||
            (employee.isResign == true && employee.totalWorkDay > 0) ||
            (employee.isResign == false && employee.totalWorkDay > 0)
          ) {
            let craftAmount = 0;
            let positionAmount = 0;
            let extraAmount = 0;
            let insuranceAmount = 0;
            let vatAmount = 0;
            let advancePayment = 0;
            craftAmount += employee.incomeCraft;
            positionAmount += employee.incomePosition;
            extraAmount += employee.incomeSpecial;
            insuranceAmount += employee.deductSS;

            vatAmount = employee.deductTax;
            rowHtml += ng.renderNormalRow(
              employee,
              craftAmount,
              positionAmount,
              extraAmount,
              insuranceAmount,
              vatAmount,
              advancePayment,
              ng.ot_rate,
              ng.absent_rate,
              ng.leave_rate,
              ng.ob_rate,
              ng.late_rate,
              ng.headReceive,
              ng.headVat,
              ng.headExpenses
            );

            groupSummary.salary += employee.salary;
            groupSummary.craftAmount += craftAmount;
            groupSummary.positionAmount += positionAmount;
            groupSummary.salaryTax += employee.processTaxDetail.salaryTax;

            if (employee.empType == 1) {
              if (employee.perDay > 0) {
                groupSummary.incomeBeforeExtraAndOT += employee.perDay * employee.totalWorkDay + craftAmount + positionAmount;
              } else {
                groupSummary.incomeBeforeExtraAndOT += employee.totalByDayEarning;
              }
            } else if (employee.empType == 2) {
              if (employee.perHour > 0) {
                groupSummary.incomeBeforeExtraAndOT += employee.perHour * employee.totalWorkhour + craftAmount + positionAmount;
              } else {
                groupSummary.incomeBeforeExtraAndOT += employee.totalEarningTypeHours;
              }
            } else {
              if (employee.isResign || employee.isNewbie) {
                groupSummary.incomeBeforeExtraAndOT += employee.perDay * employee.totalWorkDay;
              } else {
                groupSummary.incomeBeforeExtraAndOT += employee.salary + craftAmount + positionAmount;
              }
            }

            groupSummary.perDay += employee.perDay;
            groupSummary.perHour += employee.perHour;
            groupSummary.extraAmount += extraAmount;
            groupSummary.totalCommission += employee.totalCommission;
            groupSummary.extraHoliday += employee.holidaywork;
            groupSummary.extraHolidayAmount += employee.holidayworkearning;
            groupSummary.OT += employee.totalOT;

            for (var y = 0; y < ng.headReceive.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.name == ng.headReceive[y].name && c.branchPay == ng.headReceive[y].code && c.tranFlag == 0);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }
              if (groupSummaryReceive.length == ng.headReceive.length) {
                groupSummaryReceive[y] = groupSummaryReceive[y] + value;
              } else {
                groupSummaryReceive.push(value);
              }
            }
            for (var y = 0; y < ng.headVat.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.branchPay == ng.headVat[y].code && c.tranFlag == 0 && c.notCalTax == "0");
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }

              var incomeTax = 0;
              incomeTax = employee.processTaxDetail.incomeTax;

              if (groupSummaryVat.length == ng.headVat.length) {
                var val = (incomeTax * value) / (employee.totalAddIncome - employee.totalAddIncomeExceptTax);
                if (isNaN(val)) {
                  val = 0;
                }
                groupSummaryVat[y] = groupSummaryVat[y] + val;
              } else {
                var val = (incomeTax * value) / (employee.totalAddIncome - employee.totalAddIncomeExceptTax);
                if (isNaN(val)) {
                  val = 0;
                }
                groupSummaryVat.push(val);
              }
            }

            for (var y = 0; y < ng.headExpenses.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.name == ng.headExpenses[y] && c.tranFlag == 1);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }
              if (groupSummaryExpenses.length == ng.headExpenses.length) {
                groupSummaryExpenses[y] = groupSummaryExpenses[y] + value;
              } else {
                groupSummaryExpenses.push(value);
              }
            }
            for (var y = 0; y < ng.ot_rate.length; y++) {
              var value = 0;
              var ottime = 0;
              let rowz = employee.processTimes.filter((c) => c.ot_rate == ng.ot_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].ot_by_date);
                ottime += parseFloat(rowz[v].total_ottime);
              }

              if (groupSummaryOT.length == ng.ot_rate.length) {
                groupSummaryOT[y] = groupSummaryOT[y] + ottime;
                groupSummaryOTInc[y] = groupSummaryOTInc[y] + value;
              } else {
                groupSummaryOT.push(ottime);
                groupSummaryOTInc.push(value);
              }
            }
            for (var y = 0; y < ng.leave_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_leave_rate == ng.leave_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.leave_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].deduct_leave_by_date);
                time += parseFloat(rowz[v].total_leavetime);
              }

              if (groupSummaryLeave.length == ng.leave_rate.length) {
                groupSummaryLeave[y] = groupSummaryLeave[y] + time;
                groupSummaryLeaveInc[y] = groupSummaryLeaveInc[y] + value;
              } else {
                groupSummaryLeave.push(time);
                groupSummaryLeaveInc.push(value);
              }
            }
            for (var y = 0; y < ng.absent_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_absent_rate == ng.absent_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_absent_by_date);
                time += parseFloat(rowz[v].total_absenttime);
              }

              if (groupSummaryAbsent.length == ng.absent_rate.length) {
                groupSummaryAbsent[y] = groupSummaryAbsent[y] + time;
                groupSummaryAbsentInc[y] = groupSummaryAbsentInc[y] + value;
              } else {
                groupSummaryAbsent.push(time);
                groupSummaryAbsentInc.push(value);
              }
            }
            for (var y = 0; y < ng.late_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_late_rate == ng.late_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_late_by_date);
                time += parseFloat(rowz[v].total_latetime);
              }

              if (groupSummaryLate.length == ng.late_rate.length) {
                groupSummaryLate[y] = groupSummaryLate[y] + time;
                groupSummaryLateInc[y] = groupSummaryLateInc[y] + value;
              } else {
                groupSummaryLate.push(time);
                groupSummaryLateInc.push(value);
              }
            }
            for (var y = 0; y < ng.ob_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_ob_rate == ng.ob_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_ob_by_date);
                time += parseFloat(rowz[v].total_out_before_time);
              }

              if (groupSummaryOb.length == ng.ob_rate.length) {
                groupSummaryOb[y] = groupSummaryOb[y] + time;
                groupSummaryObInc[y] = groupSummaryObInc[y] + value;
              } else {
                groupSummaryOb.push(time);
                groupSummaryObInc.push(value);
              }
            }

            /* for (var k = 0; k < employee.taxLevels.length; k++) {
                             if (groupSummaryTaxlevel.length == employee.taxLevels.length) {
                                 groupSummaryTaxlevel[k] = groupSummaryTaxlevel[k] + parseFloat(employee.taxLevels[k].net);
                             } else {
                                 groupSummaryTaxlevel.push(parseFloat(employee.taxLevels[k].net))
                             }


                         }*/
            //console.log(groupSummaryTaxlevel)
            //console.log(groupSummaryOTInc)
            groupSummary.OTAmount += employee.otEarning;

            groupSummary.totalAddIncome += employee.totalAddIncome;
            groupSummary.incomeBeforeExpenses += employee.totalEarning;
            groupSummary.leave += employee.totalLeave;
            groupSummary.leaveUncut += employee.totalLeaveUncut;
            groupSummary.leaveAmount += employee.deductLeave;
            groupSummary.leaveEvent += employee.totalLeaveEvent;
            groupSummary.leaveAmountEvent += employee.deductLeaveEvent;
            groupSummary.absent += employee.totalAbsent;
            groupSummary.absentAmount += employee.deductAbsent;
            groupSummary.absentEvent += employee.totalAbsentEvent;
            groupSummary.absentAmountEvent += employee.deductAbsentEvent;

            groupSummary.lateAmount += employee.deductLate;
            groupSummary.totalLate += employee.totalLate;
            groupSummary.totalOB += employee.totalOutbefore;
            groupSummary.outBeforTimeAmount += employee.deductOutbefore;
            groupSummary.insuranceAmount += insuranceAmount;
            groupSummary.vatAmount += vatAmount;
            groupSummary.notCheckInAmount = 0.0;
            groupSummary.employeeShirtAmount = 0.0;
            groupSummary.advanceAmount = 0.0;
            groupSummary.totalAddExpenses += employee.totalAddExpenses;
            groupSummary.advancePayment += advancePayment;
            groupSummary.deductAmount += employee.totalDeduct;
            groupSummary.balanceAmount += employee.totalBalance;

            lastRowSummary.salary += employee.salary;
            lastRowSummary.craftAmount += craftAmount;
            lastRowSummary.positionAmount += positionAmount;
            lastRowSummary.salaryTax += employee.processTaxDetail.salaryTax;

            if (employee.empType == 1) {
              if (employee.perDay > 0) {
                lastRowSummary.incomeBeforeExtraAndOT += employee.perDay * employee.totalWorkDay + craftAmount + positionAmount;
              } else {
                lastRowSummary.incomeBeforeExtraAndOT += employee.totalByDayEarning;
              }
            } else if (employee.empType == 2) {
              if (employee.perHour > 0) {
                lastRowSummary.incomeBeforeExtraAndOT += employee.perHour * employee.totalWorkhour + craftAmount + positionAmount;
              } else {
                lastRowSummary.incomeBeforeExtraAndOT += employee.totalEarningTypeHours;
              }
            } else {
              if (employee.isResign || employee.isNewbie) {
                lastRowSummary.incomeBeforeExtraAndOT += employee.perDay * employee.totalWorkDay;
              } else {
                lastRowSummary.incomeBeforeExtraAndOT += employee.salary + craftAmount + positionAmount;
              }
            }

            lastRowSummary.perDay += employee.perDay;
            lastRowSummary.perHour += employee.perHour;
            lastRowSummary.extraAmount += extraAmount;
            lastRowSummary.totalCommission += employee.totalCommission;
            lastRowSummary.extraHoliday += employee.holidaywork;
            lastRowSummary.extraHolidayAmount += employee.holidayworkearning;

            for (var y = 0; y < ng.headReceive.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.name == ng.headReceive[y].name && c.branchPay == ng.headReceive[y].code && c.tranFlag == 0);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }

              if (lastSummaryReceive.length == ng.headReceive.length) {
                lastSummaryReceive[y] = lastSummaryReceive[y] + value;
              } else {
                lastSummaryReceive.push(value);
              }
            }

            for (var y = 0; y < ng.headVat.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.branchPay == ng.headVat[y].code && c.tranFlag == 0 && c.notCalTax == "0");
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }

              var incomeTax = 0;
              incomeTax = employee.processTaxDetail.incomeTax;
              if (lastSummaryVat.length == ng.headVat.length) {
                var val = (incomeTax * value) / (employee.totalAddIncome - employee.totalAddIncomeExceptTax);
                if (isNaN(val)) {
                  val = 0;
                }
                lastSummaryVat[y] = lastSummaryVat[y] + val;
              } else {
                var val = (incomeTax * value) / (employee.totalAddIncome - employee.totalAddIncomeExceptTax);
                if (isNaN(val)) {
                  val = 0;
                }
                lastSummaryVat.push(val);
              }
            }

            for (var y = 0; y < ng.headExpenses.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.name == ng.headExpenses[y] && c.tranFlag == 1);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }

              if (lastSummaryExpenses.length == ng.headExpenses.length) {
                lastSummaryExpenses[y] = lastSummaryExpenses[y] + value;
              } else {
                lastSummaryExpenses.push(value);
              }
            }
            for (var y = 0; y < ng.ot_rate.length; y++) {
              var value = 0;
              var ottime = 0;
              let rowz = employee.processTimes.filter((c) => c.ot_rate == ng.ot_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].ot_by_date);
                ottime += parseFloat(rowz[v].total_ottime);
              }

              if (lastSummaryOT.length == ng.ot_rate.length) {
                lastSummaryOT[y] = lastSummaryOT[y] + ottime;
                lastSummaryOTInc[y] = lastSummaryOTInc[y] + value;
              } else {
                lastSummaryOT.push(ottime);
                lastSummaryOTInc.push(value);
              }
            }
            for (var y = 0; y < ng.leave_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_leave_rate == ng.leave_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.leave_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].deduct_leave_by_date);
                time += parseFloat(rowz[v].total_leavetime);
              }

              if (lastSummaryLeave.length == ng.leave_rate.length) {
                lastSummaryLeave[y] = lastSummaryLeave[y] + time;
                lastSummaryLeaveInc[y] = lastSummaryLeaveInc[y] + value;
              } else {
                lastSummaryLeave.push(time);
                lastSummaryLeaveInc.push(value);
              }
            }
            for (var y = 0; y < ng.absent_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_absent_rate == ng.absent_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_absent_by_date);
                time += parseFloat(rowz[v].total_absenttime);
              }

              if (lastSummaryAbsent.length == ng.absent_rate.length) {
                lastSummaryAbsent[y] = lastSummaryAbsent[y] + time;
                lastSummaryAbsentInc[y] = lastSummaryAbsentInc[y] + value;
              } else {
                lastSummaryAbsent.push(time);
                lastSummaryAbsentInc.push(value);
              }
            }
            for (var y = 0; y < ng.late_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_late_rate == ng.late_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_late_by_date);
                time += parseFloat(rowz[v].total_latetime);
              }

              if (lastSummaryLate.length == ng.late_rate.length) {
                lastSummaryLate[y] = lastSummaryLate[y] + time;
                lastSummaryLateInc[y] = lastSummaryLateInc[y] + value;
              } else {
                lastSummaryLate.push(time);
                lastSummaryLateInc.push(value);
              }
            }
            for (var y = 0; y < ng.ob_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_ob_rate == ng.ob_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_ob_by_date);
                time += parseFloat(rowz[v].total_out_before_time);
              }

              if (lastSummaryOb.length == ng.ob_rate.length) {
                lastSummaryOb[y] = lastSummaryOb[y] + time;
                lastSummaryObInc[y] = lastSummaryObInc[y] + value;
              } else {
                lastSummaryOb.push(time);
                lastSummaryObInc.push(value);
              }
            }
            /* for (var k = 0; k < employee.taxLevels.length; k++) {
                             if (lastSummaryTaxlevel.length == employee.taxLevels.length) {
                                 lastSummaryTaxlevel[k] = lastSummaryTaxlevel[k] + parseFloat(employee.taxLevels[k].net);
                             } else {
                                 lastSummaryTaxlevel.push(parseFloat(employee.taxLevels[k].net));
                             }


                         }*/
            //console.log(lastSummaryOT)
            //console.log(lastSummaryOTInc)
            lastRowSummary.OT += employee.totalOT;
            lastRowSummary.OTAmount += employee.otEarning;
            lastRowSummary.totalAddIncome += employee.totalAddIncome;
            lastRowSummary.incomeBeforeExpenses += employee.totalEarning;
            lastRowSummary.leave += employee.totalLeave;
            lastRowSummary.leaveUncut += employee.totalLeaveUncut;
            lastRowSummary.leaveAmount += employee.deductLeave;
            lastRowSummary.leaveEvent += employee.totalLeaveEvent;
            lastRowSummary.leaveAmountEvent += employee.deductLeaveEvent;
            lastRowSummary.absent += employee.totalAbsent;
            lastRowSummary.absentAmount += employee.deductAbsent;
            lastRowSummary.absentEvent += employee.totalAbsentEvent;
            lastRowSummary.absentAmountEvent += employee.deductAbsentEvent;
            lastRowSummary.lateAmount += employee.deductLate;
            lastRowSummary.totalLate += employee.totalLate;
            lastRowSummary.totalOB += employee.totalOutbefore;
            lastRowSummary.outBeforTimeAmount += employee.deductOutbefore;
            lastRowSummary.insuranceAmount += insuranceAmount;
            lastRowSummary.vatAmount += vatAmount;
            lastRowSummary.notCheckInAmount = 0.0;
            lastRowSummary.employeeShirtAmount = 0.0;
            lastRowSummary.advanceAmount = 0.0;
            lastRowSummary.totalAddExpenses += employee.totalAddExpenses;
            lastRowSummary.advancePayment += advancePayment;
            lastRowSummary.deductAmount += employee.totalDeduct;
            lastRowSummary.balanceAmount += employee.totalBalance;
          }
        });

        footerDepartmentHtml = ng.renderGroupFooter(
          groupSummaryReceive,
          groupSummaryExpenses,
          groupSummaryTaxlevel,
          groupSummary,
          groupSummaryOTInc,
          groupSummaryOT,
          groupSummaryAbsent,
          groupSummaryAbsentInc,
          groupSummaryLeave,
          groupSummaryLeaveInc,
          groupSummaryLate,
          groupSummaryLateInc,
          groupSummaryOb,
          groupSummaryObInc,
          ng.ot_rate,
          ng.leave_rate,
          ng.absent_rate,
          ng.late_rate,
          ng.ob_rate,
          false,
          ng.headReceive,
          ng.headVat,
          ng.headExpenses,
          groupSummaryVat
        );

        ng.bodyHtml += departmentHtml + rowHtml + footerDepartmentHtml;
      }

      var footerHtmlx = ng.renderGroupFooter(
        lastSummaryReceive,
        lastSummaryExpenses,
        lastSummaryTaxlevel,
        lastRowSummary,
        lastSummaryOTInc,
        lastSummaryOT,
        lastSummaryAbsent,
        lastSummaryAbsentInc,
        lastSummaryLeave,
        lastSummaryLeaveInc,
        lastSummaryLate,
        lastSummaryLateInc,
        lastSummaryOb,
        lastSummaryObInc,
        ng.ot_rate,
        ng.leave_rate,
        ng.absent_rate,
        ng.late_rate,
        ng.ob_rate,
        true,
        ng.headReceive,
        ng.headVat,
        ng.headExpenses,
        lastSummaryVat
      );

      ng.bodyHtml += footerHtmlx;

      this.showbodyhtml = this.bodyHtml;
    },
    thousandSep(nStr) {
      if (typeof nStr !== "number" || isNaN(nStr)) {
        return 0;
      }

      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;

      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }

      return x1 + x2;
    },
    renderNormalRow(
      item,
      craftAmount,
      positionAmount,
      extraAmount,
      insuranceAmount,
      vatAmount,
      advancePayment,
      ot_rate,
      absent_rate,
      leave_rate,
      ob_rate,
      late_rate,
      headReceive,
      headVat,
      headExpenses
    ) {
      let empTypeText = "";
      let ng = this;
      if (
        (item.isResign == false && item.totalWorkDay == 0 && item.isSpecial == true) ||
        (item.isResign == true && item.totalWorkDay > 0) ||
        (item.isResign == false && item.totalWorkDay > 0)
      ) {
        //console.log(item.code)
        switch (item.empType) {
          case 0:
            empTypeText = "รายเดือน";
            break;
          case 1:
            empTypeText = "รายวัน";
            break;
          case 2:
            empTypeText = "รายชั่วโมง";
            break;
          default:
            break;
        }
        let htmlz =
          `<tr>` +
          `<td nowrap >` +
          item.code +
          `</td>` +
          `<td nowrap>` + (item.nameTitle || '') + `</td>` +
          `<td nowrap>` + (item.firstName || '') + `</td>` +
          `<td nowrap>` + (item.lastName || '') + `</td>` +
          (`<td nowrap>` + this.getBranchName(item.branch) + `</td>`) +
          (this.table_head_model.ประเภท == "1" ? `<td nowrap>` + empTypeText + `</td>` : "") +
          (this.table_head_model.ตำแหน่ง == "1" ? `<td nowrap>` + item.position + `</td>` : "") +
          (this.table_head_model.วันเริ่มทำงาน == "1" ? `<td nowrap>` + this.selectedformatDates(item.startWorkingDate) + `</td>` : "");
        if (this.table_head_model.วันทำงานเดือนนี้ == "1") {
          if (item.empType == 0) {
            if (item.isResign || item.isNewbie) {
              htmlz += `<td nowrap>` + item.totalWorkDay + `</td>`;
            } else {
              htmlz += `<td nowrap>` + item.workingDate + `</td>`;
            }
          } else if (item.empType == 2) {
            htmlz += `<td nowrap>` + item.totalWorkhour + ` ชม</td>`;
          } else {
            htmlz += `<td nowrap>` + item.totalWorkDay + `</td>`;
          }
        }

        htmlz +=
          (this.table_head_model.เงินเดือน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(item.salary) + `</td>` : "") +
          (this.table_head_model.ค่าฝีมือ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(craftAmount) + `</td>` : "") +
          (this.table_head_model.ค่าตำแหน่ง == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(positionAmount) + `</td>` : "");
        if (this.table_head_model.รวมเงินได้ == "1") {
          if (item.empType == 1) {
            if (item.perDay > 0) {
              htmlz += `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.perDay * item.totalWorkDay + craftAmount + positionAmount) + `</td>`;
            } else {
              htmlz += `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.totalByDayEarning) + `</td>`;
            }
          } else if (item.empType == 2) {
            if (item.perHour > 0) {
              htmlz +=
                `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.perHour * item.totalWorkhour + craftAmount + positionAmount) + `</td>`;
            } else {
              htmlz +=
                `<td nowrap style="text-align:right;background-color: #B2FF59">` +
                ng.thousandSep(item.totalEarningTypeHours) +
                ` <span class='fa fa-search earningdetail' role='button' code='` +
                item.code +
                `'></span></td>`;
            }
          } else {
            if (item.isResign || item.isNewbie) {
              htmlz += `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.perDay * item.totalWorkDay) + `</td>`;
            } else {
              htmlz += `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.salary + craftAmount + positionAmount) + `</td>`;
            }
          }
        }

        htmlz += this.table_head_model.วันละ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(item.perDay) + `</td>` : "";
        htmlz += this.table_head_model.ชั่วโมงละ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(item.perHour) + `</td>` : "";

        for (var i = 0; i < ot_rate.length; i++) {
          var value = 0;
          var ottime = 0;
          let rowz = item.processTimes.filter((c) => c.ot_rate == ot_rate[i]);
          for (var v = 0; v < rowz.length; v++) {
            value += parseFloat(rowz[v].ot_by_date);
            ottime += parseFloat(rowz[v].total_ottime);
          }

          htmlz += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(ottime) + `</td>` : "";
          htmlz += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(value) + `</td>` : "";
        }

        htmlz +=
          this.table_head_model.ชม_OT_รวม == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #81D4FA">` + ng.thousandSep(item.totalOT) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.เงิน_OT_รวม == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #81D4FA">` + ng.thousandSep(item.otEarning) + `</td>`
            : "";

        if (this.table_head_model.รวมรายรับอื่นๆ == "1") {
          if (this.table_head_model.รายละเอียดรายรับ == "1") {
            for (let i = 0; i < headReceive.length; i++) {
              let value = 0;
              let rowz = item.incomeAndExpenses.filter((c) => c.name == ng.headReceive[i].name && c.branchPay == ng.headReceive[i].code && c.tranFlag == 0);
              for (let v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].amount);
              }
              htmlz += `<td nowrap class="subDetail" style="text-align:right;background-color:#D1C4E9" >` + ng.thousandSep(value) + `</td>`;
            }
          }
          // htmlz += `<td nowrap style="text-align:right;background-color:#D1C4E9">` + ng.thousandSep(item.totalAddIncome) + `</td>`;
        }
        htmlz +=
          this.table_head_model.เบี้ยขยัน == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #80DEEA">` + item.totalCommission + `</td>`
            : "";
        htmlz += this.table_head_model.วันหยุดพิเศษ == "1" ? `<td nowrap style="text-align:right;background-color: #B9F6CA">` + item.holidaywork + `</td>` : "";
        htmlz +=
          this.table_head_model.รายได้วันหยุดพิเศษ == "1"
            ? `<td nowrap style="text-align:right;background-color: #B9F6CA">` + ng.thousandSep(item.holidayworkearning) + `</td>`
            : "";
        htmlz += this.table_head_model.รวมรายได้ == "1" ? `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.totalEarning) + `</td>` : "";

        for (var i = 0; i < leave_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter((c) => c.deduct_leave_rate == leave_rate[i]);
          for (var v = 0; v < rowz.length; v++) {
            //console.log(leave_rate[i] + " : " + parseFloat(rowz[v].deduct_leave_by_date))
            value += parseFloat(rowz[v].deduct_leave_by_date);
            time += parseFloat(rowz[v].total_leavetime);
          }
          //console.log(value)

          htmlz +=
            this.table_head_model.เวลาเข้างาน == "1"
              ? `<td nowrap style="text-align:right;">` +
                ng.thousandSep(time) +
                `</td>
            <td nowrap style="text-align:right;">` +
                ng.thousandSep(value) +
                `</td>`
              : "";
        }

        htmlz +=
          this.table_head_model.ชม_ลา_รวม == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #FFB74D">` + ng.thousandSep(item.totalLeave) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักเงินลา_รวม == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #FFB74D">` + ng.thousandSep(item.deductLeave) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.ลาไม่หักเงิน == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #FFF">` + ng.thousandSep(item.totalLeaveUncut) + `</td>`
            : "";

        for (var i = 0; i < absent_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter((c) => c.deduct_absent_rate == absent_rate[i]);
          for (var v = 0; v < rowz.length; v++) {
            //console.log(ot_rate[i] + " : " + parseFloat(rowz[v].ot_by_date))
            value += parseFloat(rowz[v].deduct_absent_by_date);
            time += parseFloat(rowz[v].total_absenttime);
          }
          //console.log(value)

          htmlz +=
            this.table_head_model.เวลาเข้างาน == "1"
              ? `<td nowrap style="text-align:right;">` +
                ng.thousandSep(time) +
                `</td>
            <td nowrap style="text-align:right;">` +
                ng.thousandSep(value) +
                `</td>`
              : "";
        }
        htmlz +=
          this.table_head_model.ชม_ขาด_รวม == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #EF5350">` + ng.thousandSep(item.totalAbsent) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักเงินขาด_รวม == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #EF5350">` + ng.thousandSep(item.deductAbsent) + `</td>`
            : "";

        for (var i = 0; i < late_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter((c) => c.deduct_late_rate == late_rate[i]);
          for (var v = 0; v < rowz.length; v++) {
            //console.log(ot_rate[i] + " : " + parseFloat(rowz[v].ot_by_date))
            value += parseFloat(rowz[v].deduct_late_by_date);
            time += parseFloat(rowz[v].total_latetime);
          }
          //console.log(value)

          htmlz +=
            this.table_head_model.เวลาเข้างาน == "1"
              ? `<td nowrap style="text-align:right;">` +
                ng.thousandSep(time) +
                `</td>
            <td nowrap style="text-align:right;">` +
                ng.thousandSep(value) +
                `</td>`
              : "";
        }
        htmlz +=
          this.table_head_model.สาย_รวม == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #A7FFEB">` + ng.thousandSep(item.totalLate) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักเงินสาย_รวม == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #A7FFEB">` + ng.thousandSep(item.deductLate) + `</td>`
            : "";

        for (var i = 0; i < ob_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter((c) => c.deduct_ob_rate == ob_rate[i]);
          for (var v = 0; v < rowz.length; v++) {
            //console.log(ot_rate[i] + " : " + parseFloat(rowz[v].ot_by_date))
            value += parseFloat(rowz[v].deduct_ob_by_date);
            time += parseFloat(rowz[v].total_out_before_time);
          }
          //console.log(value)

          htmlz +=
            this.table_head_model.เวลาเข้างาน == "1"
              ? `<td nowrap style="text-align:right;">` +
                ng.thousandSep(time) +
                `</td>
            <td nowrap style="text-align:right;">` +
                ng.thousandSep(value) +
                `</td>`
              : "";
        }
        htmlz +=
          this.table_head_model.ออกก่อน_รวม == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #E6EE9C">` + ng.thousandSep(item.totalOutbefore) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักออกก่อน_รวม == "1" && this.timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #E6EE9C">` + ng.thousandSep(item.deductOutbefore) + `</td>`
            : "";
        htmlz += this.table_head_model.ประกันสังคม == "1" ? `<td nowrap style="text-align:right;background-color: #FFF">` + ng.thousandSep(insuranceAmount) + `</td>` : "";
        htmlz += `<td nowrap style="text-align:right;">` + ng.thousandSep(item.processTaxDetail.salaryTax) + `</td>`;
        for (var i = 0; i < headVat.length; i++) {
          let value = 0;
          let rowz = item.incomeAndExpenses.filter((c) => c.branchPay == ng.headVat[i].code && c.tranFlag == 0 && c.notCalTax == "0");
          for (let v = 0; v < rowz.length; v++) {
            value += parseFloat(rowz[v].amount);
          }
          var incomeTax = 0;
          incomeTax = item.processTaxDetail.incomeTax;
          if (incomeTax > 0) {
            var val = (incomeTax * value) / (item.totalAddIncome - item.totalAddIncomeExceptTax);
            if (isNaN(val)) {
              val = 0;
            }

            htmlz += `<td nowrap class="" style="text-align:right; background-color:#D1C4E9" >` + ng.thousandSep(val) + `</td>`;
          } else {
            var val = 0;

            htmlz += `<td nowrap style="text-align:right;background-color:#D1C4E9 " class="">` + ng.thousandSep(val) + `</td>`;
          }
        }
        if (this.table_head_model.ภาษี == "1") {
          htmlz += `<td nowrap style="text-align:right;">` + ng.thousandSep(vatAmount) + `</td>`;
        }

        if (this.table_head_model.รวมรายจ่ายอื่นๆ == "1") {
          if (this.table_head_model.รายละเอียดรายจ่าย == "1") {
            for (var i = 0; i < headExpenses.length; i++) {
              var value = 0;

              let rowz = item.incomeAndExpenses.filter((c) => c.name == headExpenses[i] && c.tranFlag == 1);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].amount);
              }

              htmlz +=
                `
            <td nowrap style="text-align:right;background-color:#FFCCBC" class="subDetail">` +
                ng.thousandSep(value) +
                `</td>`;
            }
          }
          htmlz += `<td nowrap style="text-align:right;background-color: #FFCCBC">` + ng.thousandSep(item.totalAddExpenses) + `</td>`;
        }

        htmlz += this.table_head_model.รวมหัก == "1" ? `<td nowrap style="text-align:right;background-color: #FFAB91">` + ng.thousandSep(item.totalDeduct) + `</td>` : "";

        if (this.table_head_model.คงเหลือเงิน == "1") {
          if (item.totalBalance < 0) {
            htmlz += `<td nowrap style="text-align:right;">0.0</td>`;
          } else {
            htmlz += `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.totalBalance) + `</td>`;
          }
        }

        if (this.table_head_model.ประเภทการจ่ายเงิน == "1" && this.table_head_model.เลขที่บัญชี == "1") {
          if (item.paymentType == 0) {
            htmlz += `<td nowrap style="text-align:left;">` + item.bankName + `</td>`;
            htmlz += `<td nowrap style="text-align:left;">` + item.bankCode + `</td>`;
          } else if (item.paymentType == 1) {
            htmlz += `<td nowrap style="text-align:left;">พร้อมเพย์</td>`;
            htmlz += `<td nowrap style="text-align:left;">` + item.promptpayNumber + `</td>`;
          } else if (item.paymentType == 2) {
            htmlz += `<td nowrap style="text-align:left;">เงินสด</td>`;
            htmlz += `<td nowrap style="text-align:left;"></td>`;
          } else {
            htmlz += `<td nowrap style="text-align:left;">อื่นๆ</td>`;
            htmlz += `<td nowrap style="text-align:left;"></td>`;
          }
        }
        if (this.table_head_model.เวลาเข้างาน == "1") {
        }

        htmlz += `</tr>`;

        return htmlz;
      }
    },
    renderGroupFooter(
      groupSummaryReceive,
      groupSummaryExpenses,
      groupSummaryTaxlevel,
      groupSummary,
      groupSummaryOTInc,
      groupSummaryOT,
      groupSummaryAbsent,
      groupSummaryAbsentInc,
      groupSummaryLeave,
      groupSummaryLeaveInc,
      groupSummaryLate,
      groupSummaryLateInc,
      groupSummaryOb,
      groupSummaryObInc,
      ot_rate,
      leave_rate,
      absent_rate,
      late_rate,
      ob_rate,
      isLastRow,
      headReceive,
      headVat,
      headExpenses,
      groupSummaryVat
    ) {
      var html = "";
      let ng = this;
      html += `<tr style="background-color:` + (isLastRow ? "#5AC594" : "#dff0d8") + `">`;
      if (isLastRow) {
        html += `<td nowrap  colspan='5'>รวมทั้งหมด</td>`;
      } else {
        html += `<td nowrap  colspan='5'>รวม</td>`;
      }
      let table_head = 0;
      if (this.table_head_model.ประเภท == "1") {
        table_head += 1;
      }
      if (this.table_head_model.วันทำงานเดือนนี้ == "1") {
        table_head += 1;
      }
      if (this.table_head_model.ตำแหน่ง == "1") {
        table_head += 1;
      }
      if (this.table_head_model.วันเริ่มทำงาน == "1") {
        table_head += 1;
      }
      if (this.table_head_count > 1) {
        if (this.table_head_count <= 3) {
          html += "<td nowarp colspan='" + this.table_head_count + "'></td>";
        } else {
          console.log("tableeeee:", table_head);
          if (table_head != 0) {
            html += "<td nowarp colspan='" + table_head + "'></td>";
          } else {
          }
        }
        // html += `<td nowrap colspan=''></td> <td nowrap></td> <td nowrap></td>`;
      }
      html += this.table_head_model.เงินเดือน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.salary) + `</td>` : "";
      html += this.table_head_model.ค่าฝีมือ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.craftAmount) + `</td>` : "";
      html += this.table_head_model.ค่าตำแหน่ง == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.positionAmount) + `</td>` : "";
      html += this.table_head_model.รวมเงินได้ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.incomeBeforeExtraAndOT) + `</td>` : "";
      html += this.table_head_model.วันละ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.perDay) + `</td>` : "";
      html += this.table_head_model.ชั่วโมงละ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.perHour) + `</td>` : "";
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var s = 0; s < ot_rate.length; s++) {
          html += `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryOT[s]) + `</td>`;
          html += `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryOTInc[s]) + `</td>`;
        }
      }
      html += this.table_head_model.ชม_OT_รวม == "1" && this.timeattendance == 1 ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.OT) + `</td>` : "";
      html += this.table_head_model.เงิน_OT_รวม == "1" && this.timeattendance == 1 ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.OTAmount) + `</td>` : "";

      if (this.table_head_model.รวมรายรับอื่นๆ == "1") {
        if (this.table_head_model.รายละเอียดรายรับ) {
          for (var s = 0; s < headReceive.length; s++) {
            if (groupSummaryReceive[s] != "" && groupSummaryReceive[s] != undefined) {
              html += `<td nowrap class="subDetail" style="text-align:right;">` + ng.thousandSep(groupSummaryReceive[s]) + `</td>`;
            } else {
              html += `<td nowrap class="subDetail" style="text-align:right;">` + ng.thousandSep(0) + `</td>`;
            }
          }
        }
        // html += `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.totalAddIncome) + `</td>`;
      }
      html +=
        this.table_head_model.เบี้ยขยัน == "1" && this.timeattendance == 1 ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.totalCommission) + `</td>` : "";

      html += this.table_head_model.วันหยุดพิเศษ == "1" ? `<td nowrap style="text-align:right;">` + groupSummary.extraHoliday + `</td>` : "";
      html += this.table_head_model.รายได้วันหยุดพิเศษ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.extraHolidayAmount) + `</td>` : "";
      html += this.table_head_model.รวมรายได้ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.incomeBeforeExpenses) + `</td>` : "";
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var s = 0; s < leave_rate.length; s++) {
          if (groupSummaryLeave[s] != "" && groupSummaryLeave[s] != undefined) {
            html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryLeave[s]) + `</td>` : "";
          } else {
            html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(0) + `</td>` : "";
          }
          if (groupSummaryLeaveInc[s] != "" && groupSummaryLeaveInc[s] != undefined) {
            html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryLeaveInc[s]) + `</td>` : "";
          } else {
            html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(0) + `</td>` : "";
          }
        }
      }
      html += this.table_head_model.ชม_ลา_รวม == "1" && this.timeattendance == 1 ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.leave) + `</td>` : "";
      html +=
        this.table_head_model.หักเงินลา_รวม == "1" && this.timeattendance == 1 ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.leaveAmount) + `</td>` : "";
      html +=
        this.table_head_model.ลาไม่หักเงิน == "1" && this.timeattendance == 1 ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.leaveUncut) + `</td>` : "";
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var s = 0; s < absent_rate.length; s++) {
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryAbsent[s]) + `</td>` : "";
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryAbsentInc[s]) + `</td>` : " ";
        }
      }
      html += this.table_head_model.ชม_ขาด_รวม == "1" && this.timeattendance == 1 ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.absent) + `</td>` : "";
      html +=
        this.table_head_model.หักเงินขาด_รวม == "1" && this.timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.absentAmount) + `</td>`
          : "";
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var s = 0; s < late_rate.length; s++) {
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryLate[s]) + `</td>` : "";
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryLateInc[s]) + `</td>` : "";
        }
      }
      html += this.table_head_model.สาย_รวม == "1" && this.timeattendance == 1 ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.totalLate) + `</td>` : "";
      html +=
        this.table_head_model.หักเงินสาย_รวม == "1" && this.timeattendance == 1 ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.lateAmount) + `</td>` : "";
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var s = 0; s < ob_rate.length; s++) {
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryOb[s]) + `</td>` : "";
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryObInc[s]) + `</td>` : "";
        }
      }

      html += this.table_head_model.ออกก่อน_รวม == "1" && this.timeattendance == 1 ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.totalOB) + `</td>` : "";
      html +=
        this.table_head_model.หักออกก่อน_รวม == "1" && this.timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.outBeforTimeAmount) + `</td>`
          : "";
      html += this.table_head_model.ประกันสังคม == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.insuranceAmount) + `</td>` : "";
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var u = 0; u < groupSummaryTaxlevel.length; u++) {
          // console.log(groupSummaryTaxlevel[u]);
          html += `   <td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryTaxlevel[u]) + `</td>`;
        }
      }
      html += this.table_head_model.ภาษี == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.salaryTax) + `</td>` : "";
      for (var s = 0; s < headVat.length; s++) {
        html += `<td nowrap class="subDetail" style="text-align:right;">` + ng.thousandSep(groupSummaryVat[s]) + `</td>`;
      }
      html += this.table_head_model.ภาษี == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.vatAmount) + `</td>` : "";

      if (this.table_head_model.รวมรายจ่ายอื่นๆ == "1") {
        if (this.table_head_model.รายละเอียดรายจ่าย == "1") {
          for (var s = 0; s < headExpenses.length; s++) {
            if (groupSummaryExpenses[s] != "" && groupSummaryExpenses[s] != undefined) {
              html += `<td nowrap class="subDetail" style="text-align:right;">` + ng.thousandSep(groupSummaryExpenses[s]) + `</td>`;
            } else {
              html += `<td nowrap class="subDetail" style="text-align:right;">` + ng.thousandSep(0) + `</td>`;
            }
          }
        }
        html += `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.totalAddExpenses) + `</td>`;
      }

      html += this.table_head_model.รวมหัก == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.deductAmount) + `</td>` : "";
      html += this.table_head_model.คงเหลือเงิน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.balanceAmount) + `</td>` : "";
      html += this.table_head_model.ประเภทการจ่ายเงิน == "1" ? `<td nowrap></td>` : "";
      html += this.table_head_model.เลขที่บัญชี == "1" ? `<td nowrap></td>` : "";
      html += "</tr>";

      return html;
    },
    renderDepartment(departmentName, ot_rate, absent_rate, leave_rate, ob_rate, late_rate, item, headReceive, headExpenses) {
      let ng = this;
      let headcount = this.table_head_count;
      if (this.table_head_model.เวลาเข้างาน == "1") {
        ot_rate.forEach((element) => {
          headcount += 2;
        });
        absent_rate.forEach((element) => {
          headcount += 2;
        });
        leave_rate.forEach((element) => {
          headcount += 2;
        });
        ob_rate.forEach((element) => {
          headcount += 2;
        });
        late_rate.forEach((element) => {
          headcount += 2;
        });
      }

      let html = "";
      if (departmentName == "" || departmentName == undefined) {
        departmentName = "";
      }
      let count = 12 + this.headReceive.length + this.headVat.length;
      html += `<tr style="">`;
      html += `<td nowrap colspan='${count}'>` + departmentName + `</td>`;
      html += `</tr>`;
      headcount = 0;

      return html;
    },
    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    renderheader() {
      this.table_head_count = 1;
      let tableheader = "";
      let ng = this;
      tableheader += `<th nowrap >รหัส</th>`;
      tableheader += `<th nowrap >คำนำหน้า</th>`;
      tableheader += `<th nowrap >ชื่อ</th>`;
      tableheader += `<th nowrap >นามสกุล</th>`;
      if (this.table_head_model.ประเภท == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ประเภท</th>`;
      }
      if (this.table_head_model.ตำแหน่ง == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ตำแหน่ง</th>`;
      }
      if (this.table_head_model.วันเริ่มทำงาน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap class="text-center">วันเริ่มทำงาน</th>`;
      }
      if (this.table_head_model.วันทำงานเดือนนี้ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap class="text-center">วันทำงาน<br>เดือนนี้</th>`;
      }
      this.table_head_count += 1;
      tableheader += `<th nowrap>สาขา</th>`;
      if (this.table_head_model.เงินเดือน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>เงินเดือน</th>`;
      }
      if (this.table_head_model.ค่าฝีมือ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ค่าฝีมือ</th>`;
      }
      if (this.table_head_model.ค่าตำแหน่ง == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ค่าตำแหน่ง</th>`;
      }
      if (this.table_head_model.รวมเงินได้ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รวมเงินได้</th>`;
      }
      if (this.table_head_model.วันละ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>วันละ</th>`;
      }
      if (this.table_head_model.ชั่วโมงละ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชั่วโมงละ</th>`;
      }
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var i = 0; i < this.ot_rate.length; i++) {
          tableheader += `<th nowrap >OT ` + this.ot_rate[i] + `</th> <th nowrap >เงินOT ` + this.ot_rate[i] + `</th>`;
        }
      }

      if (this.table_head_model.ชม_OT_รวม == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชม.OT รวม</th>`;
      }
      if (this.table_head_model.เงิน_OT_รวม == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>เงิน OT รวม</th>`;
      }
      this.table_head_count += 1;
      if (this.table_head_model.รวมรายรับอื่นๆ == "1") {
        this.table_head_count += 1;
        if (this.table_head_model.รายละเอียดรายรับ) {
          for (var i = 0; i < this.headReceive.length; i++) {
            this.table_head_count += 1;
            tableheader += `<th nowrap class="text-center subDetail" >` + this.headReceive[i].label + `</th>`;
          }
        }
        // tableheader += `<th nowrap>รวมรายรับอื่นๆ</th>`;
      }
      if (this.table_head_model.เบี้ยขยัน == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>เบี้ยขยัน</th>`;
      }

      if (this.table_head_model.วันหยุดพิเศษ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>วันหยุดพิเศษ</th>`;
      }
      if (this.table_head_model.รายได้วันหยุดพิเศษ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รายได้วันหยุดพิเศษ</th>`;
      }
      if (this.table_head_model.รวมรายได้ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รวมรายได้</th>`;
      }
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var i = 0; i < this.leave_rate.length; i++) {
          tableheader += `<th nowrap >ลา ` + this.leave_rate[i] + `</th> <th nowrap >หักเงินลา ` + this.leave_rate[i] + `</th>`;
        }
      }
      if (this.table_head_model.ชม_ลา_รวม == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชม.ลา รวม</th>`;
      }
      if (this.table_head_model.หักเงินลา_รวม == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักเงินลา รวม</th>`;
      }
      if (this.table_head_model.ลาไม่หักเงิน == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ลาไม่หักเงิน (ชม.)</th>`;
      }
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var i = 0; i < this.absent_rate.length; i++) {
          tableheader += `<th nowrap >ขาด ` + this.absent_rate[i] + `</th> <th nowrap >หักเงินขาด ` + this.absent_rate[i] + `</th>`;
        }
      }

      if (this.table_head_model.ชม_ขาด_รวม == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชม.ขาด รวม</th>`;
      }
      if (this.table_head_model.หักเงินขาด_รวม == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักเงินขาด รวม</th>`;
      }
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var i = 0; i < this.late_rate.length; i++) {
          tableheader += `<th nowrap >สาย ` + this.late_rate[i] + `</th> <th nowrap >หักเงินสาย ` + this.late_rate[i] + `</th>`;
        }
      }

      if (this.table_head_model.สาย_รวม == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>สาย รวม</th>`;
      }

      if (this.table_head_model.หักเงินสาย_รวม == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักเงินสาย รวม</th>`;
      }
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var i = 0; i < this.ob_rate.length; i++) {
          tableheader += `<th nowrap >ออกก่อน ` + this.ob_rate[i] + `</th> <th nowrap >หักออกก่อน ` + this.ob_rate[i] + `</th>`;
        }
      }
      if (this.table_head_model.ออกก่อน_รวม == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ออกก่อน รวม</th>`;
      }
      if (this.table_head_model.หักออกก่อน_รวม == "1" && this.timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักออกก่อน รวม</th>`;
      }
      if (this.table_head_model.ประกันสังคม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ประกันสังคม</th>`;
      }
      if (this.table_head_model.ภาษี == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap class="text-center subDetail" >ภาษีเงินเดือน</th>`;
      }
      for (var i = 0; i < this.headVat.length; i++) {
        this.table_head_count += 1;
        tableheader += `<th nowrap class="text-center subDetail" >ภาษี:` + this.headVat[i].name + `</th>`;
      }
      tableheader += this.table_head_model.ภาษี == "1" ? `<th nowrap>รวมภาษี</th>` : "";

      if (this.table_head_model.รวมรายจ่ายอื่นๆ == "1") {
        this.table_head_count += 1;
        if (this.table_head_model.รายละเอียดรายจ่าย == "1") {
          for (var i = 0; i < this.headExpenses.length; i++) {
            this.table_head_count += 1;
            tableheader += `<th nowrap class="text-center subDetail" >` + this.headExpenses[i] + `</th>`;
          }
        }
        tableheader += `<th nowrap>รวมรายจ่ายอื่นๆ</th>`;
      }

      if (this.table_head_model.รวมหัก == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รวมหัก</th>`;
      }

      if (this.table_head_model.คงเหลือเงิน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>คงเหลือเงิน</th>`;
      }

      if (this.table_head_model.ประเภทการจ่ายเงิน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ประเภทการจ่ายเงิน</th>`;
      }
      if (this.table_head_model.เลขที่บัญชี == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>เลขที่บัญชี</th>`;
      }
      console.log("header", this.table_head_count);
      this.showheadhtml = tableheader;
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data,
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    doCopyTable() {
      let el = document.getElementById("table_detail");
      let body = document.body;
      let range;
      let sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
      }
      document.execCommand("Copy");
      alert("Copy Table to Clipboard");
    },
    doToggleHeader(status) {
      this.table_head_model = {
        ประเภท: status,
        ตำแหน่ง: status,
        วันเริ่มทำงาน: status,
        วันทำงานเดือนนี้: status,
        เงินเดือน: status,
        ค่าฝีมือ: status,
        ค่าตำแหน่ง: status,
        รวมเงินได้: status,
        วันละ: status,
        ชั่วโมงละ: status,
        ชม_OT_รวม: status,
        เงิน_OT_รวม: status,
        รายละเอียดรายรับ: status,
        รวมรายรับอื่นๆ: status,
        เบี้ยขยัน: status,
        วันหยุดพิเศษ: status,
        รายได้วันหยุดพิเศษ: status,
        รวมรายได้: status,
        ชม_ลา_รวม: status,
        หักเงินลา_รวม: status,
        ลาไม่หักเงิน: status,
        ชม_ขาด_รวม: status,
        หักเงินขาด_รวม: status,
        สาย_รวม: status,
        หักเงินสาย_รวม: status,
        ออกก่อน_รวม: status,
        หักออกก่อน_รวม: status,
        ประกันสังคม: status,
        ภาษี: status,
        รายละเอียดรายจ่าย: status,
        รวมรายจ่ายอื่นๆ: status,
        รวมหัก: status,
        คงเหลือเงิน: status,
        ประเภทการจ่ายเงิน: status,
        เลขที่บัญชี: status,
        เวลาเข้างาน: status,
      };
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          this.branch_items = res.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      SettingService.getProfileDepartmentList()
        .then((res) => {
          this.department_items = res.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.name;
      this.delDialog.emp_code = data.firstName + " " + data.lastName;
      this.delDialog.date = data.add_date;
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteExpenses(this.delDialog.roworder)
        .then((res) => {
          this.delDialogStatus = false;
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
    // แสดงตารางก่อน download
    checkbutton(buttonlist, type) {
      if (buttonlist == 1 && type == "display") {
        this.buttonlist = 1;
        console.log("table");
      } else if (buttonlist == 0 && type == "display") {
        this.buttonlist = 0;
        console.log("list");
      } else if (buttonlist == 1 && type == "downloadexcel") {
        this.buttonlist = 1;
        setTimeout(() => {
          this.checkstatus("downloadexcel");
        }, 300);
        console.log("downloadexcel");
      } else if (buttonlist == 1 && type == "doCopyTable") {
        this.buttonlist = 1;
        setTimeout(() => {
          this.checkstatus("doCopyTable");
        }, 300);
        console.log("doCopyTable");
      }
    },

    checkstatus(type) {
      let v = this;
      if (type == "downloadexcel") {
        v.downloadexcel();
      }
      if (type == "doCopyTable") {
        v.doCopyTable();
      }
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,
h3,
span,
p {
  font-family: "Prompt", sans-serif;
}
.border {
  border: 1px black solid;
}
.scroll-area {
  position: relative;
  width: 100%;
  height: 440px;
  margin-bottom: 30px;
}

/* mobile  ----------- */
@media screen and (min-width: 320px) and (max-width: 640px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* tablet  ----------- */
@media screen and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

@media screen and (min-width: 1024px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1020px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
@media only screen and (min-device-width: 772px) and (max-device-width: 1020px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
</style>
